var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _polyline, _polyline2, _polyline3, _polyline4, _line27, _line28, _line29, _line30, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadtoHeadMeVsYou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    style: {
      enableBackground: "new 0 0 720 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000127008900146854851450000011929895210707708606_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000176728566210952853720000002694932650059152306_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000058568039203711621410000000030009496170467757_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000134967048261617520960000005790459414311286163_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000120533247463486806890000004001971084652070815_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000116219580034809430490000012652757435394302893_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000183943892088234411480000004159909884449235098_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000036232395009506231650000008163326032649815432_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000179611605838594312690000016034527742408569757_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000128454683208169949450000003056852535740527544_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000016042628467571336770000011792941489337635744_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000039131758974492657930000005888769665573817012_);}\n\t\n\t\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000127017288118918122860000001040052060852672402_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000002;stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t\n\t\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000113354208386127685380000010655748523767961519_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000127765737875291155230000011826542873951815041_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000136413211991053348710000006347401536345493150_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000103985055317103988410000002873433368116471462_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-width:4.7999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000157990089663076782950000002695048540440316583_);stroke:#000002;stroke-width:2.8797;stroke-miterlimit:22.9256;}\n\t\n\t\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000151523118942098365420000005817497619328586390_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#000002;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000034069978284714655100000004484298827704390053_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000108277985274104444350000004724494660828434862_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000160171256234217182720000002820029165850535868_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000067237878919948571050000003145728450386799013_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000087393965958747076180000006991291268056957871_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000007421824401348415260000008335197283649709194_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000045612395522344353330000003231334930369458108_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000085970624478398027940000002535265817396505249_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000108285479034581687390000007405840492333246364_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000158748403897433155110000010746411009047213700_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000076563152628722357280000013962617299174671531_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000106840865855749881790000018097394663764787339_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000074438288813633397240000018087806723719358138_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000180359296792837464230000005585043203912961712_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000026844080504154121940000016626008902742349979_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000098200604318326784070000012720907888014486702_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000081647095393350475150000002917343012189904556_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000160174288807684203170000000356577230960096700_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000183232067317005494910000016571427779913458108_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000168097119553185969490000002722882215287098270_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000138568822026014187500000014636195216218975919_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000050626001628609539330000013399789535718193565_);stroke:#000002;stroke-width:1.9199;stroke-miterlimit:22.9256;}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st52{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000143607983032463311560000009796652614798702725_);stroke:#000000;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000047768992659891128920000015592594370464073106_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st54{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000090292379609185466060000016423052931399961256_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st55{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000004539377541340940370000007359200163608867757_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st56{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000078023610244026879150000009736243898774180528_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st57{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000133493195108425265440000017427824583004560005_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st58{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000182512445680559552940000003985675872028428733_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st59{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173867401454739387510000010107969800420740287_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st60{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000109008218921734572050000011552125211637122479_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st61{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000058559501320709496290000002271826612861238433_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st62{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000108998288742653485340000012390956431428033447_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st63{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173127650336365823480000012904229519195363233_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st64{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000028294815079288938730000013130521201120545707_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st65{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000059278245339984959770000011087828532770267017_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st66{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000004528785426046334290000003371880499438564264_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st67{fill-rule:evenodd;clip-rule:evenodd;fill:#640D0D;}\n\t.st68{fill-rule:evenodd;clip-rule:evenodd;fill:#4CBD94;}\n\t.st69{fill-rule:evenodd;clip-rule:evenodd;fill:#663695;}\n\t.st70{fill-rule:evenodd;clip-rule:evenodd;fill:#333333;}\n\t.st71{fill-rule:evenodd;clip-rule:evenodd;fill:#CCDB2A;}\n\t.st72{fill-rule:evenodd;clip-rule:evenodd;fill:#009999;}\n\t.st73{fill-rule:evenodd;clip-rule:evenodd;fill:#666699;}\n\t.st74{fill-rule:evenodd;clip-rule:evenodd;fill:#F7ED38;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st75{fill-rule:evenodd;clip-rule:evenodd;fill:#666699;stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t.st76{fill-rule:evenodd;clip-rule:evenodd;fill:#666699;stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st77{fill-rule:evenodd;clip-rule:evenodd;fill:#663695;stroke:#000000;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st78{fill-rule:evenodd;clip-rule:evenodd;fill:#663695;stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st79{fill-rule:evenodd;clip-rule:evenodd;fill:#663695;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st80{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t.st81{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st82{fill-rule:evenodd;clip-rule:evenodd;fill:#F7ED38;stroke:#000000;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st83{fill-rule:evenodd;clip-rule:evenodd;fill:#99CCCC;}\n\t.st84{fill-rule:evenodd;clip-rule:evenodd;fill:#99CCCC;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st85{fill-rule:evenodd;clip-rule:evenodd;fill:#CCDB2A;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st86{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.1999;stroke-linecap:round;stroke-miterlimit:22.9256;}\n\t\n\t\t.st87{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-width:1.1999;stroke-linecap:round;stroke-miterlimit:22.9256;}\n\t\n\t\t.st88{fill-rule:evenodd;clip-rule:evenodd;fill:#2B3087;stroke:#FFFFFF;stroke-width:1.1999;stroke-linecap:round;stroke-miterlimit:22.9256;}\n\t.st89{fill-rule:evenodd;clip-rule:evenodd;fill:#FCF9CE;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st90{fill-rule:evenodd;clip-rule:evenodd;fill:#2B3087;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st91{fill-rule:evenodd;clip-rule:evenodd;fill:#22205F;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st92{fill-rule:evenodd;clip-rule:evenodd;fill:#FCF9CE;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st93{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCB;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st94{fill-rule:evenodd;clip-rule:evenodd;fill:#3953A4;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st95{fill-rule:evenodd;clip-rule:evenodd;fill:#339999;stroke:#000000;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st96{fill-rule:evenodd;clip-rule:evenodd;fill:#CADB2B;stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st97{fill-rule:evenodd;clip-rule:evenodd;fill:#3953A4;stroke:#FFFFFF;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t.st98{fill-rule:evenodd;clip-rule:evenodd;fill:#2B3087;stroke:#000002;stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t.st99{fill-rule:evenodd;clip-rule:evenodd;fill:#000002;}\n\t.st100{fill-rule:evenodd;clip-rule:evenodd;fill:#A7CF38;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCB;}\n\t.st102{fill-rule:evenodd;clip-rule:evenodd;fill:#2B3087;}\n\t.st103{fill-rule:evenodd;clip-rule:evenodd;fill:#87C540;}\n\t.st104{fill-rule:evenodd;clip-rule:evenodd;fill:#640D0D;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st105{fill-rule:evenodd;clip-rule:evenodd;fill:#986828;stroke:#000002;stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t.st106{fill-rule:evenodd;clip-rule:evenodd;fill:#74BF44;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.2585,
    y1: 223.7714,
    x2: 265.3375,
    y2: 223.7714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#D32027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#232262"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.19,208.31c0.7,1.14,1.12,2.97,1.14,5.51c0.02,2.53-0.35,5.77-0.96,8.82c-0.61,3.05-1.47,5.91-2.53,8.83 c-1.06,2.92-2.31,5.88-3.92,8.27c-1.6,2.38-3.55,4.18-5.82,5.54c-2.27,1.37-4.85,2.3-7.08,2.94c-2.23,0.63-4.11,0.96-6.87,0.62 c-2.76-0.34-6.39-1.35-9.06-2.52c-2.66-1.17-4.35-2.49-5.97-4.76c-1.63-2.27-3.19-5.49-4.25-8.4c-1.06-2.92-1.62-5.54-2.03-8.15 c-0.41-2.61-0.67-5.22-0.58-7.53c0.1-2.31,0.55-4.33,1.06-5.55c0.51-1.22,1.09-1.64,2.08-1.87c1-0.22,2.41-0.25,4.26-0.58 c1.85-0.34,4.12-1,6.34-1.93c2.21-0.94,4.36-2.15,5.64-2.96c1.28-0.81,1.7-1.2,2.07-1.95c0.37-0.74,0.7-1.84,0.92-2.59 c0.22-0.75,0.35-1.16,0.81-1.35c0.47-0.19,1.28-0.18,2.2,0.21c0.92,0.39,1.96,1.14,2.38,1.97c0.42,0.83,0.22,1.74-0.29,3.59 c-0.52,1.85-1.35,4.65-2.32,8c-0.96,3.35-2.06,7.26-2.37,9.29c-0.31,2.03,0.17,2.17,0.61,2.08c0.44-0.09,0.83-0.42,1.45-2.24 c0.62-1.82,1.46-5.14,2.22-8.29c0.76-3.16,1.43-6.15,1.95-8.04c0.53-1.89,0.91-2.66,1.51-3.19c0.6-0.53,1.43-0.8,2.21-0.79 c0.78,0.01,1.51,0.3,1.96,0.77c0.45,0.47,0.63,1.12,0.32,2.77c-0.31,1.65-1.1,4.31-1.82,6.7c-0.71,2.39-1.34,4.5-1.92,6.41 c-0.57,1.91-1.08,3.62-1.35,4.76c-0.27,1.15-0.29,1.73-0.04,2.14c0.25,0.41,0.77,0.64,1.28,0.46c0.5-0.18,0.98-0.79,1.61-2.27 c0.63-1.48,1.41-3.85,2.01-5.86c0.6-2.01,1.02-3.67,1.4-5.3c0.38-1.63,0.71-3.24,0.95-4.55c0.24-1.3,0.39-2.3,0.7-2.95 c0.31-0.65,0.77-0.96,1.47-1.05c0.7-0.09,1.62,0.04,2.15,0.53c0.52,0.49,0.64,1.34,0.51,2.9c-0.13,1.56-0.51,3.82-0.99,6.06 c-0.48,2.23-1.07,4.44-1.56,6.22c-0.5,1.78-0.9,3.15-1.24,4.16c-0.34,1.01-0.61,1.67-0.63,2.23c-0.02,0.55,0.22,1,0.56,1.24 c0.33,0.25,0.76,0.3,1.19-0.02c0.43-0.32,0.86-1.01,1.31-2.14c0.45-1.13,0.92-2.7,1.41-4.48c0.5-1.78,1.02-3.78,1.36-5.54 c0.34-1.76,0.49-3.27,0.59-4.47c0.1-1.2,0.14-2.08,0.34-2.65c0.21-0.57,0.58-0.83,1.26-0.74 C262.51,206.73,263.49,207.17,264.19,208.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064331806367215936400000008312318174534290362_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.5301,
    y1: 179.7656,
    x2: 245.6648,
    y2: 179.7656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    style: {
      stopColor: "#FDB93F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#00AA8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000064331806367215936400000008312318174534290362_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M221.96,153.35c14.59,1.58,25.13,14.68,23.55,29.27c-1.58,14.59-14.68,25.13-29.27,23.55c-14.59-1.58-25.13-14.68-23.55-29.27 C194.26,162.32,207.37,151.78,221.96,153.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075138156466759284140000000766189363137237682_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.8768,
    y1: 573.002,
    x2: 258.5247,
    y2: 573.002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4771,
    style: {
      stopColor: "#6CBE45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4782,
    style: {
      stopColor: "#EE245F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000075138156466759284140000000766189363137237682_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M245.68,563.06c0.05-0.64,0.05-0.64,1.86-0.45c1.81,0.19,5.44,0.58,7.25,0.77c1.81,0.19,1.81,0.19,1.78,1.03 c-0.03,0.84-0.1,2.52,0.14,4c0.24,1.48,0.8,2.75,1.2,3.83c0.4,1.07,0.64,1.94,0.61,3c-0.04,1.05-0.35,2.29-1,3.47 c-0.66,1.18-1.65,2.3-2.76,3.15c-1.11,0.84-2.33,1.41-3.67,1.59c-1.34,0.17-2.79-0.04-4.07-0.63c-1.28-0.59-2.38-1.55-3.24-2.7 c-0.87-1.14-1.5-2.46-1.76-3.72c-0.26-1.26-0.16-2.45,0.32-3.54c0.48-1.09,1.34-2.07,1.91-3.15c0.58-1.08,0.88-2.26,1.08-3.5 C245.53,564.98,245.63,563.7,245.68,563.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124129545808442162350000017696833932096972973_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.7577,
    y1: 559.0189,
    x2: 257.1969,
    y2: 559.0189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#EE245F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#6CBE45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000124129545808442162350000017696833932096972973_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M245.86,557.69c-0.04,0.59-0.08,1.6-0.1,2.1c-0.02,0.51-0.02,0.51,1.85,0.64c1.87,0.13,5.6,0.4,7.47,0.53 c1.87,0.13,1.87,0.13,1.92-0.44c0.05-0.57,0.14-1.71,0.19-2.28c0.05-0.57,0.05-0.57-1.83-0.72c-1.88-0.15-5.63-0.45-7.53-0.52 C245.93,556.94,245.89,557.11,245.86,557.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088845618314844219330000006042854609263935911_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.0385,
    y1: 526.1577,
    x2: 268.4395,
    y2: 526.1577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#EE245F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000088845618314844219330000006042854609263935911_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M248.07,554.93c-1.82-0.21-1.84-0.38-2.01-1.28c-0.17-0.9-0.48-2.52-1.12-4.7c-0.64-2.18-1.59-4.93-2.22-7.03 c-0.63-2.1-0.93-3.57-0.44-4.55c0.48-0.98,1.75-1.48,2.83-3.73c1.07-2.25,1.95-6.25,2.67-10c0.71-3.75,1.26-7.24,2.1-11 c0.84-3.76,1.97-7.79,2.58-10.56c0.61-2.77,0.69-4.29,2.52-4.92c1.83-0.63,5.41-0.37,7.21-0.24s1.79,0.13,2.23,0.9 c0.43,0.77,1.3,2.31,2.01,4.21s1.26,4.16,1.59,6.64c0.33,2.47,0.46,5.16,0.43,7.8c-0.02,2.64-0.2,5.23-0.7,8.26 c-0.5,3.02-1.33,6.47-2.25,9.42c-0.92,2.95-1.94,5.4-2.96,7.52c-1.02,2.12-2.04,3.92-2.81,5.5c-0.77,1.58-1.28,2.95-1.66,4.32 c-0.38,1.38-0.64,2.77-0.78,3.46c-0.13,0.69-0.13,0.69-1.94,0.57C253.52,555.38,249.9,555.14,248.07,554.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055703567092088544800000002338284760078128028_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.2056,
    y1: 93.8657,
    x2: 296.2025,
    y2: 93.8657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000055703567092088544800000002338284760078128028_)"
    },
    d: " M277.72,77.44c1.04,0.22,3.77,1.36,6.39,3.13c2.62,1.77,5.12,4.16,7.07,6.65c1.96,2.49,3.37,5.08,4.15,6.7 c0.78,1.62,0.92,2.27,0.85,3.86c-0.07,1.58-0.34,4.1-0.81,6.01c-0.47,1.91-1.14,3.22-1.95,4.29c-0.81,1.08-1.75,1.93-2.41,2.18 c-0.66,0.25-1.05-0.11-1.26-1.62c-0.21-1.51-0.24-4.16-0.51-7c-0.28-2.84-0.8-5.86-1.8-8.84c-1-2.97-2.49-5.89-4.14-8.24 c-1.65-2.35-3.47-4.14-4.72-5.39C277.35,77.93,276.68,77.22,277.72,77.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000926852257548385320000016228422729967480475_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.6872,
    y1: 91.3945,
    x2: 286.7515,
    y2: 91.3945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000000926852257548385320000016228422729967480475_)"
    },
    d: " M270.39,76.12c2.28,0.99,4.55,2.51,6.74,4.86c2.18,2.36,4.28,5.55,5.92,8.96c1.64,3.41,2.84,7.04,3.37,10.01 c0.53,2.97,0.38,5.29-0.03,6.68c-0.41,1.39-1.1,1.84-2.33,1.44c-1.23-0.4-3-1.65-5.56-3.46c-2.56-1.81-5.91-4.19-9.03-6.7 c-3.12-2.51-6.01-5.16-8.54-7.28c-2.53-2.13-4.68-3.74-6.93-5.04c-2.24-1.3-4.58-2.3-6.69-2.84c-2.11-0.55-4.01-0.65-4.94-0.85 c-0.93-0.21-0.9-0.52,0.14-1.26c1.03-0.74,3.07-1.89,5.19-2.88c2.12-0.99,4.33-1.81,6.99-2.37c2.66-0.56,5.76-0.86,8.46-0.78 C265.82,74.67,268.11,75.13,270.39,76.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085960206946897797920000007535118574197098420_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.7928,
    y1: 101.586,
    x2: 286.6807,
    y2: 101.586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000085960206946897797920000007535118574197098420_)"
    },
    d: " M286.54,112.96c0.31,1.52,0.02,4.24-0.13,5.61c-0.15,1.36-0.15,1.36-3.23,0.98s-9.26-1.16-14.97-1.78 c-5.71-0.62-10.96-1.08-15.48-1.94c-4.52-0.86-8.3-2.12-11.62-3.32c-3.31-1.21-6.16-2.36-8.32-3.44c-2.16-1.08-3.64-2.09-4.38-2.65 c-0.73-0.56-0.72-0.66-0.45-2.22c0.28-1.56,0.81-4.58,1.61-7.09c0.8-2.51,1.87-4.52,3.19-6.49c1.33-1.98,2.92-3.93,4.05-5.13 c1.14-1.2,1.82-1.66,2.59-1.89c0.77-0.24,1.62-0.25,3.38,0.15c1.76,0.4,4.43,1.22,6.93,2.55c2.51,1.33,4.85,3.18,7.29,5.14 c2.44,1.96,4.97,4.04,7.64,6.29c2.67,2.25,5.48,4.67,7.88,6.52c2.4,1.85,4.38,3.12,6.29,4.13c1.91,1,3.74,1.73,5.11,2.25 C285.31,111.13,286.23,111.44,286.54,112.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021083400552710483310000017871394661684550566_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.6829,
    y1: 124.6991,
    x2: 286.066,
    y2: 124.6991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0492,
    style: {
      stopColor: "#7E762F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000021083400552710483310000017871394661684550566_)"
    },
    d: " M282.78,123.26c-3.38-0.58-10.19-1.32-15.95-1.99c-5.76-0.68-10.46-1.29-14.65-2.22c-4.19-0.93-7.87-2.18-11.14-3.38 c-3.26-1.2-6.11-2.36-8.33-3.34c-2.23-0.98-3.83-1.79-4.76-2.05c-0.93-0.26-1.17,0.03-1.24,1.67c-0.07,1.64,0.03,4.61,0.77,7.56 c0.74,2.94,2.12,5.85,3.45,8.32c1.32,2.48,2.59,4.52,4.05,6.16c1.47,1.64,3.13,2.88,5.27,3.75c2.13,0.87,4.73,1.36,7.58,1.46 c2.85,0.1,5.96-0.2,9.06-0.93c3.1-0.72,6.19-1.87,8.85-2.96c2.66-1.09,4.89-2.12,7.05-2.95c2.16-0.83,4.24-1.45,6.3-1.86 c2.06-0.41,4.1-0.62,5.21-0.66c1.12-0.04,1.32,0.09,1.46-0.74c0.14-0.83,0.23-2.63,0.3-3.73 C286.12,124.25,286.16,123.83,282.78,123.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085954431096685963020000008241650740515077281_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.8199,
    y1: 140.0324,
    x2: 283.6595,
    y2: 140.0324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3536,
    style: {
      stopColor: "#E71E25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000085954431096685963020000008241650740515077281_)"
    },
    d: " M283.65,132.79c-0.08-0.75-1.13-0.86-2.74-0.61c-1.62,0.25-3.8,0.86-6.29,1.81c-2.49,0.95-5.28,2.24-7.93,3.28 c-2.66,1.04-5.18,1.83-7.84,2.44c-2.66,0.61-5.47,1.05-7.77,1.23c-2.3,0.18-4.09,0.09-5.15,0.08c-1.06-0.01-1.38,0.06-0.86,0.6 c0.53,0.53,1.9,1.53,4.13,2.51c2.23,0.98,5.3,1.95,8.62,2.63c3.32,0.68,6.88,1.06,9.25,1.21c2.37,0.15,3.54,0.07,5.01-0.78 c1.47-0.85,3.23-2.46,4.93-4.4c1.69-1.94,3.32-4.2,4.57-6.02C282.84,134.92,283.73,133.54,283.65,132.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180327703132795451970000011339291732724475024_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.9179,
    y1: 139.3207,
    x2: 293.0796,
    y2: 139.3207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#D32027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000180327703132795451970000011339291732724475024_)"
    },
    d: " M292.32,133.09c-0.97-0.32-3.06-0.65-4.38-0.63c-1.33,0.02-1.9,0.38-2.89,1.75c-1,1.38-2.42,3.77-3.93,5.99 c-1.51,2.22-3.11,4.27-3.8,5.26c-0.69,0.99-0.47,0.9,0.83,0.2c1.3-0.71,3.67-2.04,6.13-3.79c2.47-1.75,5.03-3.91,6.51-5.29 c1.47-1.38,1.86-1.97,2.12-2.42C293.15,133.71,293.29,133.4,292.32,133.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127736523738630233560000015188478167595134596_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.7645,
    y1: 126.2949,
    x2: 299.3336,
    y2: 126.2949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#D32027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000127736523738630233560000015188478167595134596_)"
    },
    d: " M294.54,131.15c-0.62,0.3-1.23,0.13-2.38-0.05c-1.15-0.18-2.82-0.36-3.66-0.5c-0.83-0.14-0.82-0.25-0.63-1.5 c0.19-1.25,0.55-3.65,0.74-4.85c0.18-1.2,0.18-1.2,0.78-1.29c0.59-0.09,1.78-0.28,3.12-0.46c1.34-0.17,2.84-0.33,3.98-0.52 c1.13-0.2,1.9-0.43,2.34-0.59c0.44-0.16,0.56-0.26,0.48,0.42c-0.07,0.68-0.34,2.14-0.86,3.51c-0.52,1.37-1.3,2.67-1.99,3.71 C295.77,130.07,295.15,130.85,294.54,131.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124139996103033118590000011164897689440527794_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.9435,
    y1: 109.34,
    x2: 300.8097,
    y2: 109.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#D32027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#454896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000124139996103033118590000011164897689440527794_)"
    },
    d: " M299.84,117.42c-0.77,0.71-2.23,1.51-3.93,2.01c-1.7,0.51-3.63,0.72-4.8,0.81c-1.18,0.09-1.59,0.04-1.86,0.01 c-0.26-0.03-0.37-0.04-0.28-1.36c0.09-1.32,0.37-3.93,0.57-5.24c0.19-1.3,0.3-1.29,0.74-1.4c0.44-0.11,1.2-0.35,2.11-0.88 c0.91-0.54,1.95-1.38,2.76-2.46c0.81-1.08,1.37-2.4,1.85-3.83c0.47-1.43,0.85-2.98,1.04-4.23c0.19-1.25,0.19-2.21,0.31-2.4 c0.13-0.2,0.39,0.36,0.78,1.62c0.39,1.26,0.92,3.23,1.24,5.22c0.31,2,0.41,4.02,0.44,5.72c0.03,1.7-0.01,3.07-0.07,4.07 C300.68,116.07,300.61,116.7,299.84,117.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008108256638562864540000007745878096428568737_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.5608,
    y1: 430.5342,
    x2: 250.4816,
    y2: 430.5342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#0B8040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#2F469D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000008108256638562864540000007745878096428568737_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M218.15,473.65c1.59,0.51,4.77,1.12,6.36,1.42c1.59,0.3,1.59,0.3,2.59-8.13c1-8.43,3-25.3,4.24-34.63 c1.24-9.33,1.71-11.13,2.68-13.9c0.97-2.77,2.44-6.51,4.13-9.91c1.69-3.4,3.59-6.46,5.65-9.45c2.06-2.99,4.26-5.9,5.47-7.67 c1.21-1.77,1.43-2.38,1.06-2.21c-0.37,0.17-1.32,1.12-2.45,2.16c-1.13,1.04-2.45,2.16-3.86,3.88c-1.41,1.72-2.9,4.05-4.41,6.62 c-1.51,2.57-3.03,5.39-4.27,8.26c-1.24,2.88-2.21,5.81-2.71,7.36c-0.5,1.55-0.53,1.71-1.35,1.65c-0.82-0.05-2.41-0.32-3.21-0.49 c-0.79-0.17-0.77-0.25-0.87-1.51c-0.1-1.26-0.31-3.71-0.81-6.76c-0.5-3.05-1.28-6.69-2.16-10.07c-0.88-3.38-1.86-6.49-3-8.88 c-1.14-2.4-2.43-4.08-3.36-4.91c-0.94-0.82-1.53-0.79-1.17,0.45c0.35,1.24,1.65,3.67,2.79,6.77c1.15,3.1,2.15,6.88,3.01,10.38 c0.86,3.5,1.57,6.71,1.94,9.19c0.37,2.48,0.41,4.23,0.34,5.87c-0.07,1.64-0.23,3.18-1.61,12.02c-1.38,8.85-3.97,25-5.27,33.29 C216.57,472.73,216.56,473.14,218.15,473.65z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M234.59,394.38c2.56,0.24,5.99,0.53,8.98-0.27c2.99-0.8,5.54-2.69,8.23-5.23c2.7-2.54,5.54-5.73,7.83-8.88 c2.3-3.14,4.04-6.24,5.46-10.28c1.41-4.04,2.49-9.02,3.02-13.54c0.52-4.52,0.49-8.58-0.22-12.71c-0.72-4.13-2.13-8.32-3.67-11.72 c-1.54-3.4-3.21-5.99-4.93-7.98c-1.72-1.99-3.49-3.36-5.38-4.56s-3.91-2.21-6.52-2.94c-2.61-0.73-5.83-1.18-8.66-0.92 c-2.83,0.26-5.27,1.22-7.6,2.41c-2.33,1.19-4.54,2.62-6.85,4.68c-2.31,2.07-4.72,4.77-6.97,8.09c-2.25,3.32-4.34,7.25-5.87,11.43 c-1.53,4.18-2.49,8.61-2.77,12.77s0.12,8.05,0.97,12.13c0.85,4.08,2.17,8.33,3.28,11.41c1.11,3.08,2.03,4.97,3.75,7.12 c1.73,2.15,4.27,4.57,6.4,6c2.13,1.43,3.85,1.89,5.56,2.22C230.33,393.94,232.03,394.14,234.59,394.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170957225581511064380000009184303441926132140_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.0507,
    y1: 414.2423,
    x2: 266.2495,
    y2: 414.2423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#E2E555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#79C143"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000170957225581511064380000009184303441926132140_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M247.06,409.75c0.04,0.48,0.26,1.47,0.69,2.38c0.43,0.91,1.08,1.73,1.73,2.46c0.65,0.74,1.3,1.38,2.18,2.01 c0.89,0.63,2.01,1.23,3.18,1.66c1.17,0.43,2.38,0.69,3.76,0.8c1.38,0.11,2.94,0.07,4.17-0.15c1.23-0.22,2.14-0.61,2.7-1.11 c0.56-0.5,0.76-1.12,0.78-1.68c0.01-0.56-0.16-1.05-0.57-1.72c-0.41-0.67-1.06-1.53-1.77-2.13c-0.72-0.6-1.5-0.96-2.6-1.19 c-1.1-0.23-2.5-0.34-4.2-0.38c-1.7-0.03-3.71,0.02-5.24-0.09c-1.54-0.1-2.61-0.36-3.29-0.59c-0.69-0.23-0.99-0.45-1.21-0.58 C247.15,409.32,247.02,409.27,247.06,409.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145042123433482823920000001057485266677700245_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.4595,
    y1: 405.065,
    x2: 272.4601,
    y2: 405.065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#E2E555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#79C143"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000145042123433482823920000001057485266677700245_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M252.79,394.47c-0.71,0.37-1.62,1.02-2.51,1.97c-0.89,0.95-1.75,2.2-2.42,3.59c-0.67,1.38-1.15,2.9-1.32,4.11 c-0.17,1.21-0.04,2.12,0.15,2.75c0.19,0.63,0.45,0.97,0.93,1.3c0.48,0.32,1.17,0.63,2.23,0.84c1.06,0.22,2.49,0.35,4.13,0.39 c1.64,0.04,3.5,0,5.1,0.09c1.6,0.09,2.94,0.3,4.06,0.82c1.12,0.52,2.03,1.34,2.68,2.05c0.65,0.71,1.04,1.32,1.23,1.82 c0.19,0.5,0.19,0.89,0.19,1.19c0,0.3,0,0.52,0.11,0.65c0.11,0.13,0.32,0.17,0.69-0.15c0.37-0.32,0.89-1.02,1.6-2.05 c0.71-1.04,1.62-2.42,2.14-3.67c0.52-1.25,0.65-2.38,0.67-3.67c0.02-1.3-0.06-2.77-0.26-3.7c-0.19-0.93-0.5-1.32-0.89-1.53 c-0.39-0.22-0.86-0.26-1.49-0.39c-0.63-0.13-1.41-0.35-2.33-0.89c-0.93-0.54-2.01-1.4-3.11-2.2c-1.1-0.8-2.23-1.53-3.42-2.12 c-1.19-0.58-2.44-1.02-3.52-1.28c-1.08-0.26-1.99-0.35-2.7-0.35S253.5,394.1,252.79,394.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141449168969827483050000005463748834015306397_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.6315,
    y1: 396.0654,
    x2: 271.4477,
    y2: 396.0654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#E2E555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#79C143"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000141449168969827483050000005463748834015306397_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M256.1,393.06c0.57,0.12,1.75,0.27,2.97,0.58c1.22,0.32,2.49,0.81,3.64,1.39c1.15,0.59,2.17,1.27,2.96,1.86 c0.78,0.59,1.32,1.08,1.93,1.47c0.61,0.39,1.29,0.68,1.9,0.92c0.6,0.24,1.13,0.43,1.47,0.5c0.35,0.07,0.52,0.03,0.48-0.21 c-0.04-0.24-0.3-0.67-0.78-1.25c-0.48-0.58-1.17-1.32-1.95-1.97c-0.78-0.65-1.64-1.21-2.64-1.75c-0.99-0.54-2.12-1.06-3.22-1.43 c-1.1-0.37-2.18-0.58-3.16-0.71c-0.97-0.13-1.84-0.17-2.51-0.11c-0.67,0.07-1.15,0.24-1.4,0.37 C255.55,392.85,255.52,392.94,256.1,393.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101072104147290795450000009493991978657234579_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.758,
    y1: 547.6732,
    x2: 246.2598,
    y2: 547.6732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#EE245F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000101072104147290795450000009493991978657234579_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M209.79,598.86c2.14,1.15,6.61,2.79,8.97,3.55c2.35,0.76,2.59,0.65,5.43-8.38c2.83-9.02,8.26-26.96,10.98-36.03 c2.72-9.07,2.72-9.27,2.31-9.95c-0.42-0.68-1.25-1.86-1.75-2.6c-0.49-0.75-0.64-1.07-0.25-2.42c0.4-1.35,1.34-3.74,1.91-5.03 c0.57-1.29,0.78-1.48,1.44-1.84c0.66-0.36,1.79-0.88,2.47-1.2c0.68-0.32,0.92-0.43,1.79-2.88c0.86-2.45,2.35-7.24,2.91-10.77 c0.56-3.53,0.19-5.8-0.41-8.25c-0.6-2.45-1.44-5.09-2.93-7.67c-1.49-2.58-3.63-5.09-5.84-6.9c-2.2-1.81-4.47-2.9-7.37-3.9 c-2.9-0.99-6.44-1.89-9.59-1.94c-3.15-0.05-5.9,0.74-8.77,1.92c-2.87,1.18-5.84,2.76-8.2,4.83c-2.36,2.07-4.09,4.63-5.29,7.73 c-1.2,3.09-1.86,6.72-1.83,10.02c0.02,3.31,0.73,6.3,1.99,9.76c1.27,3.46,3.09,7.4,5.04,11.81c1.95,4.41,4.03,9.3,5.51,13.54 c1.48,4.24,2.37,7.83,3.02,12.06c0.65,4.24,1.06,9.12,0.83,13.76c-0.23,4.65-1.11,9.06-1.91,12.06c-0.8,3.01-1.52,4.61-1.97,5.74 C207.82,597.04,207.64,597.71,209.79,598.86z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M205.18,525.37c3.83,8.25,13.62,11.83,21.86,8c8.25-3.83,11.83-13.62,8-21.86c-3.83-8.25-13.62-11.83-21.86-8 C204.93,507.34,201.35,517.13,205.18,525.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097475105284145833640000017385927093650663824_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.8383,
    y1: 488.1518,
    x2: 235.7561,
    y2: 488.1518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000097475105284145833640000017385927093650663824_)",
      stroke: "#000002",
      strokeWidth: 2.8797,
      strokeMiterlimit: 22.9256
    },
    d: " M221.55,491.28c1.76,3.79,6.2,5.46,9.93,3.73c3.72-1.73,5.32-6.2,3.56-9.99c-1.76-3.79-6.2-5.46-9.93-3.73 C221.39,483.02,219.8,487.49,221.55,491.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023999108200585812360000000398696914969731771_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.5822,
    y1: 430.4866,
    x2: 269.7687,
    y2: 430.4866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#63CBE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#8DD4D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000023999108200585812360000000398696914969731771_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M239.25,415.8c-0.33,0.05-0.75,0.4-1.27,1.33c-0.52,0.94-1.16,2.47-1.6,4.5c-0.44,2.03-0.69,4.57-0.77,6.62s0.02,3.62,0.21,4.82 c0.19,1.2,0.46,2.04,0.9,2.58c0.43,0.54,1.02,0.79,3.49,2.19c2.46,1.4,6.8,3.96,9.2,5.32c2.4,1.37,2.85,1.54,3.47,1.72 c0.63,0.18,1.43,0.35,2.28,0.3c0.85-0.05,1.76-0.32,3.17-1.17c1.41-0.85,3.33-2.27,5.04-3.79c1.71-1.52,3.21-3.15,4.29-4.44 c1.08-1.28,1.75-2.22,1.99-2.91c0.25-0.69,0.07-1.15-0.13-1.46c-0.21-0.31-0.45-0.49-0.89-0.47c-0.43,0.02-1.06,0.22-1.51,0.08 c-0.45-0.14-0.73-0.63-1.04-1.08c-0.31-0.45-0.66-0.87-1.42-0.84c-0.77,0.03-1.95,0.51-2.59,0.67c-0.64,0.15-0.75-0.02-1.01-0.63 c-0.26-0.61-0.67-1.65-1.04-2.33c-0.36-0.68-0.67-0.99-1.14-1.15c-0.47-0.16-1.1-0.16-1.88-0.04c-0.78,0.12-1.72,0.36-2.25,0.43 c-0.52,0.07-0.63-0.04-0.68-0.72c-0.05-0.68-0.05-1.93-0.15-2.63c-0.1-0.7-0.31-0.84-0.92-0.65c-0.61,0.19-1.62,0.71-2.26,0.86 c-0.64,0.15-0.92-0.06-1.15-0.7c-0.22-0.64-0.39-1.72-0.58-2.37c-0.19-0.64-0.4-0.85-0.87-0.73c-0.47,0.12-1.2,0.57-1.69,0.67 c-0.49,0.1-0.73-0.14-1.09-0.75c-0.36-0.61-0.85-1.59-1.35-1.95c-0.5-0.37-1.03-0.13-1.51,0.12c-0.49,0.24-0.94,0.48-1.32,0.52 c-0.38,0.03-0.7-0.14-0.87-0.42c-0.17-0.28-0.21-0.66-0.34-0.98C239.83,415.99,239.58,415.74,239.25,415.8z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M238.77,439.6c2.81,1.33,8.37,4.34,11.16,5.9c2.79,1.56,2.83,1.66,2.74,1.82c-0.09,0.16-0.3,0.36-3.04-0.97 c-2.74-1.33-8.02-4.2-10.75-5.69c-2.73-1.49-2.9-1.59-2.95-1.82S235.96,438.27,238.77,439.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M237.7,445.86c2.22,0.95,6.56,3.15,8.7,4.33c2.14,1.17,2.07,1.31,1.91,1.5c-0.16,0.19-0.4,0.43-2.55-0.55 c-2.15-0.98-6.22-3.19-8.28-4.33c-2.07-1.14-2.13-1.21-2.12-1.4C235.37,445.23,235.48,444.91,237.7,445.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064333230281027790370000007816067914172431789_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.5453,
    y1: 455.5567,
    x2: 245.2297,
    y2: 455.5567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#63CBE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#8DD4D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000064333230281027790370000007816067914172431789_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M235.81,449.68c2.01,0.95,5.83,2.91,7.73,3.98c1.89,1.07,1.86,1.24,1.51,1.8c-0.35,0.56-1.01,1.49-1.73,2.45 c-0.72,0.95-1.49,1.93-2.5,2.72c-1.01,0.8-2.27,1.42-3.36,1.57c-1.1,0.15-2.03-0.16-2.99-0.92c-0.95-0.75-1.92-1.94-2.44-3.19 c-0.52-1.25-0.58-2.58-0.35-3.95c0.23-1.37,0.76-2.8,1.09-3.68c0.33-0.89,0.47-1.23,0.65-1.44 C233.59,448.8,233.8,448.74,235.81,449.68z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M237.35,439.82c-0.38,1.83-0.76,3.66-1.14,5.49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M240.38,441.48c-0.67,1.56-1.34,3.12-1.67,3.9c-0.33,0.78-0.33,0.78-0.33,0.78"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M242.92,442.85c-0.69,1.49-1.38,2.98-2.08,4.47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171710168143011315490000000704646707840141757_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.2098,
    y1: 446.3853,
    x2: 245.5506,
    y2: 446.3853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#63CBE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#D4E167"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000171710168143011315490000000704646707840141757_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M245.55,444.26c-0.78,1.42-1.56,2.83-2.34,4.25"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M248.25,445.67c-0.89,1.36-1.77,2.72-2.66,4.08"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M251.13,447.04c-1.11,1.32-2.21,2.65-3.32,3.97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175302804176952804270000017607981287207987590_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.1783,
    y1: 272.0156,
    x2: 282.5599,
    y2: 272.0156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    style: {
      stopColor: "#FDB93F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#00AA8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000175302804176952804270000017607981287207987590_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M279.71,295.33c0.63-1.55,1-4.81,1.25-8.29c0.25-3.49,0.37-7.19,0.5-10.65c0.12-3.46,0.25-6.66,0.48-11.31 c0.23-4.65,0.56-10.73,0.62-13.91c0.06-3.18-0.16-3.44-1.75-3.61c-1.58-0.17-4.53-0.23-6.03-0.14c-1.5,0.09-1.56,0.35-1.72,0.7 c-0.16,0.35-0.41,0.8-1.54,1.06c-1.13,0.26-3.12,0.33-4.15,0.44c-1.03,0.11-1.09,0.25-0.1,2.9c0.99,2.66,3.03,7.83,4.15,10.43 c1.12,2.6,1.33,2.64,1.95,2.77c0.62,0.13,1.64,0.36,2.36,0.7c0.72,0.35,1.13,0.81,1.36,1.3c0.23,0.49,0.28,1.02,0.13,1.6 c-0.15,0.58-0.48,1.22-2.85,2.5c-2.37,1.29-6.76,3.22-9,4.28c-2.24,1.06-2.32,1.25-2.11,1.99c0.21,0.74,0.71,2.03,1.07,2.72 c0.37,0.7,0.6,0.8,2.08,0.19c1.48-0.61,4.2-1.94,5.98-2.72c1.78-0.79,2.62-1.03,3.19-1.17c0.57-0.14,0.87-0.18,1.2-0.06 c0.34,0.12,0.72,0.4,0.94,0.98c0.22,0.58,0.29,1.45,0.21,2.06c-0.07,0.61-0.29,0.97-2.07,1.81c-1.78,0.84-5.12,2.17-6.9,2.96 c-1.78,0.79-2,1.03-1.92,1.54c0.08,0.51,0.46,1.3,0.91,1.81c0.45,0.51,0.97,0.74,1.41,1.32c0.44,0.59,0.81,1.54,1.13,2.33 c0.32,0.79,0.61,1.42,1.41,1.77c0.8,0.35,2.11,0.43,2.83,0.66c0.71,0.23,0.82,0.62,0.92,0.97c0.1,0.35,0.18,0.67,0.46,0.88 c0.27,0.21,0.74,0.3,1.41,0.43C278.2,296.71,279.08,296.87,279.71,295.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035490012215745020040000000650381710822561971_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0279,
    y1: 261.58,
    x2: 271.852,
    y2: 261.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000035490012215745020040000000650381710822561971_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M262.9,272.28c1.84-0.98,5.35-3.08,7.17-4.27c1.82-1.19,1.94-1.47,1.68-2.21c-0.27-0.74-0.92-1.92-1.72-3.48 c-0.8-1.56-1.74-3.49-2.63-5.6c-0.89-2.11-1.74-4.39-2.24-5.54c-0.5-1.15-0.66-1.16-1.26-1.03c-0.59,0.13-1.61,0.41-2.11,0.78 c-0.5,0.37-0.48,0.83-0.44,2.45c0.04,1.62,0.1,4.4,0.05,6.99c-0.05,2.59-0.21,4.99-0.44,6.77c-0.23,1.78-0.52,2.95-0.7,3.68 c-0.18,0.73-0.26,1.04-0.23,1.22c0.03,0.18,0.17,0.24,0.31,0.39c0.13,0.14,0.26,0.37,0.41,0.54 C260.89,273.13,261.06,273.26,262.9,272.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016058846148279735710000006022070547756022958_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.3031,
    y1: 261.1238,
    x2: 260.6386,
    y2: 261.1238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000016058846148279735710000006022070547756022958_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M256.76,270.49c0.38-2.13,0.6-6.31,0.83-8.62c0.24-2.31,0.49-2.76,0.81-2.98c0.32-0.22,0.71-0.22,1.09-0.11 c0.37,0.11,0.73,0.32,0.91,0.54s0.19,0.45,0.21-1.06c0.02-1.51,0.05-4.75-0.13-6.38c-0.18-1.62-0.57-1.63-1.67-1.55 c-1.1,0.08-2.91,0.23-4.43,0.23c-1.52,0-2.74-0.15-3.84-0.32c-1.1-0.18-2.08-0.38-3.58-0.54c-1.5-0.16-3.53-0.27-4.81-0.11 c-1.28,0.16-1.81,0.6-2.26,0.85c-0.45,0.25-0.81,0.31-1.59,0.11c-0.78-0.2-1.98-0.68-2.8-0.9c-0.83-0.23-1.29-0.2-1.71,0.31 c-0.42,0.51-0.81,1.52-0.06,4.13c0.76,2.61,2.66,6.82,3.56,9.3c0.9,2.48,0.8,3.22,0.62,3.87c-0.18,0.65-0.43,1.22-0.15,1.93 c0.28,0.71,1.07,1.57,1.99,2.11c0.91,0.54,1.93,0.77,2.91,0.98c0.98,0.21,1.9,0.39,2.79,0.42c0.89,0.03,1.73-0.11,2.09-2.05 c0.36-1.95,0.22-5.72,0.16-7.93c-0.06-2.22-0.04-2.88,0.08-3.42c0.12-0.54,0.36-0.94,0.68-1.22c0.32-0.28,0.73-0.44,1.11-0.41 c0.38,0.03,0.74,0.24,0.99,0.61c0.26,0.37,0.42,0.89,0.68,3.11c0.25,2.22,0.6,6.14,0.82,8.25c0.22,2.12,0.3,2.44,0.55,2.63 c0.25,0.19,0.67,0.27,1.14,0.34c0.47,0.07,1.01,0.14,1.55,0.12C255.83,272.72,256.38,272.62,256.76,270.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000925354821103027400000011244601192473128875_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.9017,
    y1: 182.0986,
    x2: 275.0725,
    y2: 182.0986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#AFD136"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#4454A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#2D429A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6782,
    style: {
      stopColor: "#130E3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#4552A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000000925354821103027400000011244601192473128875_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M247.54,161.43c-0.41,0.08-1.08,0.35-1.73,0.76c-0.65,0.41-1.27,0.95-1.62,1.38c-0.35,0.42-0.42,0.73-0.02,1.46 c0.4,0.73,1.26,1.88,2.11,3.13c0.85,1.25,1.67,2.58,2.34,3.66c0.67,1.07,1.17,1.88,1.55,2.68c0.37,0.8,0.61,1.6,0.58,2.43 c-0.03,0.83-0.32,1.71-0.85,2.94c-0.53,1.24-1.31,2.83-1.74,4.25c-0.43,1.42-0.51,2.65-0.44,3.82c0.08,1.17,0.31,2.27,0.76,3.43 c0.45,1.16,1.11,2.36,1.97,3.6c0.87,1.24,1.94,2.51,3.06,3.57c1.13,1.06,2.3,1.91,3.74,2.63c1.44,0.72,3.14,1.31,4.65,1.53 c1.5,0.22,2.8,0.06,4.17-0.33c1.37-0.39,2.8-1.03,3.97-1.86c1.17-0.84,2.08-1.88,2.89-3.21c0.81-1.33,1.54-2.96,1.88-4.77 c0.34-1.81,0.31-3.81,0.02-5.58c-0.28-1.77-0.82-3.32-1.52-4.67c-0.7-1.35-1.56-2.5-2.49-3.58c-0.92-1.08-1.9-2.09-3.12-2.87 c-1.21-0.78-2.66-1.33-4.06-1.56c-1.39-0.23-2.73-0.13-3.76-0.08c-1.03,0.05-1.76,0.05-2.47-0.13c-0.71-0.18-1.4-0.54-2-1.11 c-0.59-0.56-1.09-1.33-1.8-2.52c-0.71-1.18-1.63-2.78-2.5-4.23c-0.87-1.45-1.68-2.75-2.16-3.49c-0.48-0.74-0.61-0.92-0.75-1.07 C248.09,161.47,247.95,161.35,247.54,161.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134929644342649969020000007633991491073369264_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.0937,
    y1: 223.6485,
    x2: 166.6269,
    y2: 223.6485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000134929644342649969020000007633991491073369264_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M156.04,209.12c8.02,2.58,12.43,11.18,9.85,19.21c-2.58,8.02-11.18,12.43-19.21,9.85c-8.02-2.58-12.43-11.18-9.85-19.21 C139.41,210.95,148.01,206.54,156.04,209.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145026938521207622920000008490517284079538336_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.6321,
    y1: 214.5884,
    x2: 142.3968,
    y2: 214.8014
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000145026938521207622920000008490517284079538336_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M141.03,215.36c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C139.94,215.48,140.5,215.19,141.03,215.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129186637124197119600000000815437167263744405_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.987,
    y1: 216.4576,
    x2: 142.7517,
    y2: 216.6706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000129186637124197119600000000815437167263744405_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M139.6,218.84c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C138.51,218.96,139.08,218.67,139.6,218.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059311307792830859220000006549500364819101602_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.9731,
    y1: 218.8447,
    x2: 143.7378,
    y2: 219.0578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000059311307792830859220000006549500364819101602_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M139.02,222.65c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C137.93,222.77,138.5,222.48,139.02,222.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045597667105603359010000017440350606160476035_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1455,
    y1: 218.6133,
    x2: 144.9102,
    y2: 218.8263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000045597667105603359010000017440350606160476035_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M142.04,220.75c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C140.94,220.87,141.51,220.58,142.04,220.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003067200603005577680000010156787726474338203_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.4707,
    y1: 216.6003,
    x2: 144.2355,
    y2: 216.8133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000003067200603005577680000010156787726474338203_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M142.89,217.35c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C141.8,217.47,142.36,217.18,142.89,217.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046301617331496092720000015460269698658643629_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.4567,
    y1: 221.2928,
    x2: 145.2214,
    y2: 221.5058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000046301617331496092720000015460269698658643629_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M139.54,225.98c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C138.44,226.1,139.01,225.81,139.54,225.98z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049913927910334213580000017368550267078123418_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.2454,
    y1: 220.7017,
    x2: 146.0101,
    y2: 220.9148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000049913927910334213580000017368550267078123418_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M142.08,223.79c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C140.99,223.91,141.56,223.62,142.08,223.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149369384338206689880000005939290310059303080_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.5012,
    y1: 224.046,
    x2: 147.2659,
    y2: 224.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000149369384338206689880000005939290310059303080_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M140.98,229.27c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C139.89,229.39,140.46,229.1,140.98,229.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120531812706281577960000008628652298897870519_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.9953,
    y1: 223.074,
    x2: 147.76,
    y2: 223.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000120531812706281577960000008628652298897870519_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M143.31,226.64c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C142.21,226.76,142.78,226.47,143.31,226.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142878598812333724800000002133000712867883955_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.5694,
    y1: 226.4425,
    x2: 149.3342,
    y2: 226.6555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000142878598812333724800000002133000712867883955_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M142.91,231.79c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C141.82,231.91,142.39,231.62,142.91,231.79z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M145.83,234.12c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C144.73,234.24,145.3,233.95,145.83,234.12z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M149.19,235.31c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C148.1,235.43,148.66,235.14,149.19,235.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163041225484292076020000003973537088544493729_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.0373,
    y1: 225.6286,
    x2: 149.802,
    y2: 225.8416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000163041225484292076020000003973537088544493729_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M144.99,229.53c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C143.89,229.65,144.46,229.36,144.99,229.53z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M147.77,231.85c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C146.68,231.97,147.25,231.68,147.77,231.85z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M143.67,213.05c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C142.58,213.17,143.15,212.88,143.67,213.05z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M152.32,235.26c0.53,0.17,0.82,0.74,0.65,1.26c-0.17,0.53-0.74,0.82-1.26,0.65c-0.53-0.17-0.82-0.74-0.65-1.26 C151.22,235.38,151.79,235.09,152.32,235.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132787613780626233020000000125492759424960660_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.4635,
    y1: 269.4265,
    x2: 212.2277,
    y2: 269.4265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000132787613780626233020000000125492759424960660_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M148.75,257.04c1.7,2.31,5.44,6.42,9.78,10.59c4.34,4.17,9.26,8.39,13.68,11.93c4.41,3.54,8.32,6.39,11.59,8.93 c3.27,2.54,5.91,4.75,8.25,6.84c2.34,2.08,4.36,4.04,5.93,5.63c1.57,1.59,2.68,2.81,3.6,3.66c0.92,0.85,1.65,1.32,2.31,1.52 c0.66,0.19,1.24,0.1,2-0.13c0.76-0.23,1.69-0.6,2.15-0.81c0.46-0.21,0.44-0.27,0.23-0.64c-0.22-0.37-0.64-1.04-1.1-1.32 c-0.47-0.27-0.98-0.14-1.57-0.07c-0.59,0.06-1.26,0.06-2.07-0.4c-0.82-0.45-1.78-1.35-2.9-2.51c-1.12-1.16-2.41-2.58-3.43-4.04 c-1.02-1.46-1.78-2.96-2.25-4.32c-0.48-1.36-0.68-2.58-0.49-3.48c0.19-0.9,0.76-1.47,1.6-1.87c0.83-0.4,1.93-0.63,2.89-0.64 c0.97-0.01,1.81,0.19,2.91,1.05c1.11,0.86,2.47,2.38,3.51,3.66c1.03,1.28,1.73,2.31,2.4,3.37c0.67,1.07,1.33,2.17,1.69,3.07 c0.36,0.91,0.42,1.62,0.24,2.3c-0.18,0.68-0.62,1.34-0.93,1.76c-0.32,0.42-0.51,0.59-0.32,0.99c0.2,0.4,0.79,1.04,1.39,1.03 c0.6-0.01,1.22-0.65,1.7-1.38c0.47-0.73,0.81-1.55,0.66-2.69c-0.15-1.14-0.78-2.61-1.9-4.69c-1.12-2.07-2.73-4.74-4.38-7.67 c-1.65-2.93-3.34-6.13-4.9-9.56c-1.57-3.44-3.02-7.12-4.68-10.77c-1.66-3.66-3.52-7.29-5.71-11.11c-2.19-3.82-4.69-7.83-6.83-11.24 c-2.14-3.41-3.91-6.22-5.16-8.01c-1.26-1.79-2.01-2.56-2.6-2.98c-0.6-0.42-1.04-0.49-1.6-0.34c-0.57,0.15-1.26,0.51-1.41,0.98 c-0.15,0.46,0.24,1.03,1.27,2.42c1.03,1.4,2.71,3.62,4.65,6.51c1.94,2.89,4.14,6.43,6.04,9.63c1.9,3.2,3.5,6.05,4.53,8.36 c1.03,2.31,1.49,4.06,1.88,5.54c0.39,1.47,0.7,2.67,0.72,3.57c0.02,0.9-0.24,1.52-0.66,1.99c-0.42,0.47-1,0.81-1.72,0.97 c-0.72,0.16-1.57,0.14-2.58-0.47c-1.01-0.61-2.18-1.82-4.15-4.15c-1.98-2.33-4.76-5.78-8.56-10.67c-3.8-4.88-8.61-11.2-11.16-14.35 c-2.55-3.15-2.85-3.13-3.38-2.93c-0.52,0.2-1.27,0.58-1.67,0.89c-0.4,0.32-0.46,0.57,0.97,2.41c1.42,1.84,4.32,5.26,7.37,9.01 c3.04,3.75,6.24,7.82,8.74,10.89c2.5,3.07,4.32,5.14,5.6,6.9c1.28,1.76,2.02,3.2,2.36,4.47c0.34,1.28,0.26,2.39-0.1,3.18 c-0.37,0.79-1.03,1.27-1.75,1.52c-0.72,0.25-1.5,0.27-2.52-0.03c-1.02-0.31-2.28-0.95-4.42-2.54c-2.15-1.59-5.18-4.13-7.91-6.56 c-2.73-2.44-5.16-4.77-7.42-7.02c-2.26-2.26-4.35-4.44-5.93-6.08c-1.58-1.65-2.66-2.76-3.33-3.43c-0.66-0.67-0.91-0.91-1.19-0.84 c-0.28,0.07-0.61,0.46-0.94,0.91C147.41,254.21,147.06,254.73,148.75,257.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098205546792907535760000009697092335252874917_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.622,
    y1: 252.9161,
    x2: 190.5432,
    y2: 252.9161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#4454A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6782,
    style: {
      stopColor: "#130E3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#4552A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000098205546792907535760000009697092335252874917_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M164.13,241.61c1.97,2.79,5.99,8.16,9.73,12.93c3.74,4.78,7.2,8.96,9.39,11.54c2.19,2.58,3.11,3.55,3.92,4.06 c0.8,0.52,1.49,0.58,2.06,0.46c0.57-0.12,1.04-0.42,1.23-0.99c0.19-0.56,0.09-1.39-0.47-3.06c-0.56-1.67-1.59-4.19-2.94-6.93 c-1.35-2.74-3.04-5.69-5.38-9.41c-2.34-3.72-5.34-8.21-7.12-10.86c-1.79-2.65-2.37-3.47-2.75-3.89c-0.38-0.41-0.57-0.43-2.12,0.13 c-1.55,0.56-4.47,1.69-5.96,2.35C162.23,238.62,162.16,238.82,164.13,241.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027566863888809770710000004031380365131407007_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.4802,
    y1: 260.3083,
    x2: 181.9404,
    y2: 260.3083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#4454A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6782,
    style: {
      stopColor: "#130E3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#4552A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000027566863888809770710000004031380365131407007_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M151.96,253.44c1.83,2.01,5.5,5.83,8.82,9.11c3.32,3.28,6.28,6.02,8.83,8.23c2.55,2.21,4.69,3.89,6.28,4.99 c1.59,1.1,2.64,1.61,3.43,1.74c0.79,0.13,1.33-0.14,1.79-0.44c0.47-0.3,0.86-0.65,0.83-1.34c-0.03-0.69-0.48-1.72-2.04-3.95 c-1.56-2.23-4.21-5.65-7.19-9.39c-2.98-3.73-6.28-7.78-8.66-10.7c-2.37-2.92-3.82-4.73-4.81-5.95c-0.99-1.23-1.52-1.87-1.91-2.32 c-0.39-0.44-0.63-0.68-1.81,0.63c-1.17,1.31-3.27,4.16-4.33,5.68C150.14,251.25,150.13,251.44,151.96,253.44z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M218.44,166.33c1.54,0.17,2.65,1.55,2.48,3.08c-0.17,1.54-1.55,2.65-3.08,2.48c-1.54-0.17-2.65-1.55-2.48-3.08 C215.53,167.28,216.91,166.17,218.44,166.33z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M210.74,173.8c1.54,0.17,2.65,1.55,2.48,3.08c-0.17,1.54-1.55,2.65-3.08,2.48c-1.54-0.17-2.65-1.55-2.48-3.08 C207.83,174.74,209.21,173.63,210.74,173.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M236.33,163.7c0.32,1.14,1.65,3.58,2.47,5.78c0.82,2.2,1.12,4.15,1.15,6.29c0.03,2.14-0.22,4.45-0.71,6.74 c-0.48,2.29-1.2,4.56-2.17,6.4c-0.97,1.84-2.2,3.25-3.5,4.61c-1.3,1.36-2.66,2.67-4.22,3.69c-1.56,1.03-3.33,1.77-5.29,2.29 c-1.95,0.52-4.09,0.8-6.15,0.95c-2.06,0.15-4.03,0.17-5.74-0.01c-1.71-0.19-3.17-0.58-4.17-0.87c-1-0.3-1.54-0.49-1.91-0.51 c-0.37-0.02-0.58,0.15-0.62,0.5c-0.04,0.35,0.09,0.88,0.98,1.58c0.88,0.7,2.52,1.59,4.5,2.15c1.98,0.57,4.29,0.82,6.64,0.81 c2.34,0,4.72-0.26,7.03-0.86c2.31-0.59,4.57-1.52,6.53-2.69c1.96-1.17,3.61-2.59,5.09-4.14c1.48-1.55,2.79-3.24,3.79-4.89 c1-1.65,1.69-3.26,2.26-5.1c0.57-1.84,1.03-3.9,1.29-5.81c0.25-1.92,0.31-3.69,0.01-5.48c-0.3-1.79-0.95-3.59-1.72-5.3 c-0.78-1.7-1.68-3.3-2.45-4.44c-0.77-1.14-1.4-1.82-2.05-2.24C236.69,162.73,236.01,162.56,236.33,163.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 229.29,
    y1: 393.57,
    x2: 239.57,
    y2: 314.83
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 224.52,
    y1: 392.53,
    x2: 234.56,
    y2: 315.56
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 219.77,
    y1: 391.5,
    x2: 229.26,
    y2: 318.77
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 215.76,
    y1: 384.85,
    x2: 223.86,
    y2: 322.81
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 211.89,
    y1: 377.18,
    x2: 218.25,
    y2: 328.42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 233.92,
    y1: 394.57,
    x2: 244.19,
    y2: 315.83
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 238.66,
    y1: 395.6,
    x2: 248.94,
    y2: 316.86
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 243.41,
    y1: 396.63,
    x2: 253.68,
    y2: 317.88
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 248.9,
    y1: 391.89,
    x2: 257.97,
    y2: 322.39
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 254.53,
    y1: 386.14,
    x2: 262.27,
    y2: 326.81
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 260.29,
    y1: 379.08,
    x2: 266.03,
    y2: 335.06
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 268.65,
    y1: 358.95,
    x2: 209.42,
    y2: 351.23
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 267.63,
    y1: 363.65,
    x2: 209.09,
    y2: 356.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 265.77,
    y1: 368.25,
    x2: 208.58,
    y2: 360.79
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 264.39,
    y1: 372.95,
    x2: 209.37,
    y2: 365.77
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 262.21,
    y1: 377.58,
    x2: 210.51,
    y2: 370.83
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 258.76,
    y1: 382.01,
    x2: 211.9,
    y2: 375.89
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 254.31,
    y1: 386.27,
    x2: 212.81,
    y2: 380.85
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 249.92,
    y1: 390.61,
    x2: 216.6,
    y2: 386.26
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 268.51,
    y1: 354.1,
    x2: 210,
    y2: 346.47
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 269.54,
    y1: 349.36,
    x2: 211.21,
    y2: 341.75
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 268.15,
    y1: 344.3,
    x2: 212.92,
    y2: 337.09
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 267.49,
    y1: 339.34,
    x2: 215.68,
    y2: 332.58
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 265.79,
    y1: 334.24,
    x2: 218.41,
    y2: 328.06
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 263.27,
    y1: 329.03,
    x2: 223.49,
    y2: 323.84
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 267.83,
    y1: 324.24,
    x2: 237.32,
    y2: 316.85
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "247.44,271.52 247.62,272.27 251.7,272.56 252.08,271.71 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "255.54,272.08 255.71,272.83 259.8,273.12 260.17,272.28 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "260.93,273.19 260.36,273.72 262.17,277.4 263.09,277.3 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "265.19,281.63 264.59,282.11 266.13,285.91 267.05,285.87 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031918260426686863020000003053089478635821184_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.9911,
    y1: 200.5076,
    x2: 189.6508,
    y2: 200.5076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000031918260426686863020000003053089478635821184_)",
      stroke: "#000002",
      strokeWidth: 1.9199,
      strokeMiterlimit: 22.9256
    },
    d: " M176.2,181.77c-0.96,0.46-1.99,1.26-2.85,3.27c-0.86,2.01-1.54,5.23-2.19,8.44c-0.64,3.2-1.25,6.39-1.63,9.32 c-0.38,2.94-0.55,5.63-0.54,7.81c0,2.18,0.17,3.85,0.72,5.19c0.55,1.34,1.5,2.34,3.12,2.97c1.63,0.63,3.94,0.88,5.8,0.99 c1.86,0.11,3.28,0.07,4.44-0.47c1.16-0.54,2.06-1.59,2.8-2.9c0.74-1.31,1.32-2.88,1.61-4.23c0.29-1.35,0.3-2.47-0.32-3.69 c-0.63-1.22-1.89-2.54-2.85-3.49c-0.96-0.94-1.62-1.51-2-2.19c-0.38-0.68-0.47-1.49-0.22-2.04c0.25-0.55,0.84-0.86,1.4-1.17 c0.56-0.31,1.08-0.64,1.78-1.04c0.69-0.41,1.56-0.91,2.29-1.76c0.73-0.85,1.33-2.07,1.71-3.67c0.38-1.6,0.52-3.59,0.28-5.25 c-0.24-1.66-0.87-2.99-1.76-3.94c-0.89-0.95-2.04-1.53-3.56-1.95c-1.52-0.42-3.4-0.67-4.79-0.73 C178.04,181.17,177.16,181.3,176.2,181.77z"
  }), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st51",
    x1: 168.83,
    y1: 205.2,
    x2: 186.15,
    y2: 215.87
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st51",
    x1: 170.16,
    y1: 200.96,
    x2: 187.82,
    y2: 212.27
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st51",
    x1: 172.39,
    y1: 187.98,
    x2: 187.54,
    y2: 196.78
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st51",
    x1: 173.98,
    y1: 183.82,
    x2: 189.25,
    y2: 193.11
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M235.79,208.63c-0.1,1.08-0.58,3.17-1.14,4.19c-0.56,1.02-1.22,0.97-2.11,1.08c-0.89,0.11-2,0.37-2.58,0.31 c-0.58-0.06-0.61-0.44-0.7-1.14c-0.09-0.7-0.23-1.7-0.22-2.37c0.01-0.66,0.18-0.99,0.76-1.3c0.58-0.31,1.56-0.61,2.55-0.95 c0.99-0.34,1.99-0.71,2.63-0.85C235.62,207.47,235.89,207.55,235.79,208.63z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M226.66,211.07c-0.82,0.01-2.45,0.49-3.2,0.9c-0.75,0.41-0.63,0.74-0.43,1.32c0.2,0.58,0.47,1.4,0.7,1.88 c0.23,0.48,0.41,0.61,0.93,0.5c0.52-0.11,1.36-0.45,1.92-0.69c0.56-0.24,0.82-0.39,0.93-0.87c0.11-0.49,0.06-1.32,0.03-1.96 C227.5,211.51,227.49,211.06,226.66,211.07z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M233.17,215.65c-0.54,0.06-1.48,0.23-2.17,0.32c-0.7,0.09-1.15,0.1-1.33,0.6c-0.19,0.5-0.11,1.49-0.03,2.22 c0.08,0.73,0.16,1.2,0.46,1.44c0.3,0.24,0.82,0.24,1.24,0.19c0.43-0.06,0.76-0.18,1.09-0.68c0.33-0.49,0.67-1.36,0.92-2.1 c0.26-0.74,0.44-1.35,0.47-1.68C233.85,215.63,233.71,215.59,233.17,215.65z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M227.32,217.1c-0.64-0.34-1.69-0.06-2.17,0.32c-0.48,0.38-0.4,0.85-0.25,1.45c0.15,0.6,0.38,1.34,0.61,1.7 c0.23,0.36,0.45,0.36,0.85,0.25c0.4-0.1,0.98-0.3,1.36-0.56c0.37-0.26,0.55-0.58,0.51-1.22C228.19,218.4,227.96,217.44,227.32,217.1 z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M226.75,224.32c0.05,0.94,0.6,2.59,1.39,4.17c0.79,1.57,1.83,3.07,2.87,4.2c1.04,1.13,2.08,1.88,3.2,2.48 c1.12,0.6,2.33,1.03,3.22,1.3c0.89,0.26,1.45,0.36,1.76,0.19c0.31-0.17,0.36-0.6,0.45-1.02c0.09-0.42,0.21-0.83-0.55-1.39 c-0.76-0.56-2.41-1.28-3.71-2.15c-1.3-0.87-2.26-1.9-3.02-2.83c-0.76-0.93-1.33-1.77-1.8-2.69c-0.47-0.92-0.84-1.92-1.04-2.61 c-0.2-0.69-0.24-1.07-0.53-1.2c-0.3-0.13-0.86,0-1.36,0.19C227.15,223.14,226.7,223.38,226.75,224.32z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M254.58,238.88c-0.94,0.8-2.67,2.36-4.41,3.44c-1.73,1.08-3.47,1.68-5.15,1.95c-1.68,0.28-3.3,0.24-4.91,0.02 c-1.61-0.22-3.2-0.62-4.02-0.61c-0.82,0.01-0.88,0.44-0.25,0.85c0.62,0.41,1.92,0.8,3.55,1.06c1.63,0.26,3.59,0.4,5.31,0.25 c1.72-0.16,3.19-0.61,4.56-1.2c1.37-0.6,2.63-1.33,3.7-2.2c1.08-0.87,1.97-1.86,2.42-2.62c0.45-0.76,0.46-1.28,0.38-1.52 C255.68,238.05,255.53,238.08,254.58,238.88z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M261.78,211.68c-0.97-0.48-2.95-1.07-4-1.05c-1.05,0.02-1.16,0.66-0.65,1.15c0.51,0.49,1.64,0.84,2.49,1.1 c0.85,0.25,1.43,0.41,1.89,0.4c0.46-0.02,0.82-0.21,1.01-0.48C262.72,212.51,262.75,212.15,261.78,211.68z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M253.74,208.72c-0.33-0.4-1.02-0.82-1.95-1.18c-0.93-0.35-2.11-0.63-2.79-0.61c-0.68,0.02-0.85,0.34-0.76,0.67 c0.09,0.32,0.44,0.65,1.16,0.98c0.72,0.33,1.81,0.65,2.64,0.86c0.83,0.21,1.39,0.31,1.69,0.17 C254.04,209.48,254.07,209.11,253.74,208.72z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M246.46,204.76c-0.76-0.45-2.29-1.05-3.3-1.28c-1.01-0.23-1.5-0.08-1.78,0.25c-0.28,0.32-0.36,0.82,0.02,1.17 c0.38,0.35,1.2,0.54,2.03,0.75c0.83,0.21,1.66,0.43,2.29,0.46c0.63,0.03,1.05-0.14,1.27-0.38 C247.2,205.5,247.21,205.21,246.46,204.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086655138495116741500000014801686717349765544_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.4998,
    y1: 601.1102,
    x2: 268.1433,
    y2: 601.1102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000086655138495116741500000014801686717349765544_)",
      stroke: "#000000",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M197.14,545.23c-0.08,7.68,0.4,22.08,0.2,33.92c-0.2,11.84-1.08,21.12-2.32,29.28c-1.24,8.16-2.84,15.2-4.6,21.12 c-1.76,5.92-3.68,10.72-4.48,14.44c-0.8,3.72-0.48,6.36,0.72,8.32c1.2,1.96,3.28,3.24,6.44,3.92c3.16,0.68,7.4,0.76,11.6,1.36 c4.2,0.6,8.36,1.72,12.48,2.92c4.12,1.2,8.2,2.48,12.84,3.24c4.64,0.76,9.84,1,14.32,1.16c4.48,0.16,8.24,0.24,11.24-0.08 c3-0.32,5.24-1.04,7.28-2.08c2.04-1.04,3.88-2.4,4.72-3.4c0.84-1,0.68-1.64-0.08-2.56c-0.76-0.92-2.12-2.12-4.24-2.96 c-2.12-0.84-5-1.32-7.68-1.64c-2.68-0.32-5.16-0.48-9.12-2.08c-3.96-1.6-9.4-4.64-14.24-7.84c-4.84-3.2-9.08-6.56-11.44-9.44 c-2.36-2.88-2.84-5.28-2.72-8.76c0.12-3.48,0.84-8.04,1.44-11.24c0.6-3.2,1.08-5.04,1-6c-0.08-0.96-0.72-1.04-3.28-2.04 c-2.56-1-7.04-2.92-9.32-4.24c-2.28-1.32-2.36-2.04-2.12-3.44c0.24-1.4,0.8-3.48,1.48-6.16c0.68-2.68,1.48-5.96,1.84-9.56 c0.36-3.6,0.28-7.52-0.2-11.52c-0.48-4-1.36-8.08-2.48-12.48c-1.12-4.4-2.48-9.12-3.84-12.8c-1.36-3.68-2.72-6.32-3.72-7.16 C197.86,536.59,197.22,537.55,197.14,545.23z"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M208.48,165.06c1.54,0.17,2.65,1.55,2.48,3.08c-0.17,1.54-1.55,2.65-3.08,2.48c-1.54-0.17-2.65-1.55-2.48-3.08 C205.57,166.01,206.94,164.9,208.48,165.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062172272137138131190000001950561680231864983_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.0658,
    y1: 227.2929,
    x2: 180.4654,
    y2: 227.2929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000062172272137138131190000001950561680231864983_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M170.11,232.08c3.09-2.16,7.92-5.9,9.61-7.77c1.69-1.87,0.24-1.87-1.64-1.95c-1.88-0.08-4.2-0.25-5.76-0.7 c-1.56-0.45-2.37-1.18-2.89-1.56c-0.52-0.38-0.76-0.4-0.86,0.47c-0.09,0.87-0.05,2.65-0.15,4.33c-0.1,1.68-0.35,3.26-0.82,4.62 c-0.47,1.36-1.15,2.49-1.74,3.43c-0.59,0.94-1.07,1.69-0.64,1.78C165.67,234.82,167.02,234.24,170.11,232.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138545192470260292650000009566461401109023164_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.9426,
    y1: 203.6866,
    x2: 204.9955,
    y2: 203.6866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000138545192470260292650000009566461401109023164_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M191.91,215.37c2.9-1.54,8.54-5.27,11.15-7.44c2.61-2.17,2.19-2.78,1.04-3.67c-1.15-0.89-3.04-2.06-4.61-3.48 c-1.58-1.42-2.84-3.08-3.82-4.88c-0.97-1.8-1.65-3.72-2.17-4.46c-0.52-0.74-0.89-0.3-1.15,1c-0.26,1.3-0.41,3.46-0.98,4.92 c-0.56,1.47-1.53,2.25-2.02,3.04c-0.49,0.79-0.49,1.6-0.22,2.39c0.28,0.79,0.83,1.58,1.13,2.58c0.29,1,0.32,2.21,0.27,3.45 c-0.05,1.24-0.19,2.51-0.52,3.65c-0.32,1.13-0.83,2.12-1,2.95S189.01,216.9,191.91,215.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031906832586187237020000012568834117104801713_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.3847,
    y1: 199.7656,
    x2: 169.2982,
    y2: 199.7656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#4454A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6782,
    style: {
      stopColor: "#130E3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#4552A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000031906832586187237020000012568834117104801713_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M152,204.21c0.92,0.42,2.81,0.79,4.74,1.56c1.93,0.77,3.89,1.95,5.26,3.1c1.36,1.15,2.13,2.28,2.75,2.83 c0.62,0.55,1.11,0.52,1.3-0.5c0.19-1.03,0.09-3.05,0.17-5.29c0.08-2.24,0.35-4.71,0.73-7.12c0.38-2.41,0.88-4.77,1.37-6.73 c0.49-1.96,0.98-3.51,0.98-4.2c-0.01-0.68-0.51-0.5-2.19,0.89c-1.68,1.39-4.53,3.98-7.38,6.52c-2.85,2.55-5.7,5.06-7.15,6.55 C151.13,203.31,151.08,203.79,152,204.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083088820500819063350000003043414853015825064_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.575,
    y1: 172.3111,
    x2: 195.4071,
    y2: 172.3111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000083088820500819063350000003043414853015825064_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M181.04,176.37c1.88-2.13,5.84-5.97,8.69-8.59c2.86-2.63,4.62-4.05,5.31-4.45c0.69-0.41,0.3,0.19-0.41,1.89 c-0.71,1.69-1.73,4.48-2.44,6.94c-0.71,2.46-1.1,4.59-1.26,6.1c-0.16,1.51-0.1,2.4-0.23,2.83c-0.13,0.43-0.45,0.39-0.91,0.22 c-0.46-0.17-1.07-0.48-2.12-0.87c-1.04-0.39-2.52-0.88-3.95-1.07c-1.43-0.19-2.81-0.1-3.59-0.27 C179.36,178.93,179.16,178.5,181.04,176.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101071943270983347900000009560744281364102023_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.9612,
    y1: 242.2432,
    x2: 154.6117,
    y2: 242.2432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000101071943270983347900000009560744281364102023_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M137.07,234.38c0.35,1.24,1.6,4.52,3.1,7.78c1.5,3.26,3.24,6.51,4.34,7.83c1.1,1.33,1.57,0.73,2.58-0.44 c1.01-1.18,2.57-2.94,3.92-4.24c1.35-1.3,2.48-2.14,3.12-2.8c0.63-0.66,0.77-1.12-0.39-1.25c-1.15-0.13-3.59,0.09-5.92-0.28 c-2.33-0.37-4.56-1.34-6.21-2.48c-1.65-1.14-2.71-2.47-3.52-3.52C137.28,233.92,136.72,233.13,137.07,234.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109714229041416903170000003368907505258171013_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.1925,
    y1: 295.4077,
    x2: 263.6934,
    y2: 295.4077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    style: {
      stopColor: "#FDB93F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#00AA8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000109714229041416903170000003368907505258171013_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M212.46,294.24c0.35,0.08,1.3,0.99,2.42,1.07c1.12,0.08,2.41-0.66,3.85-1.72c1.44-1.05,3.04-2.41,4.73-4.32 c1.7-1.91,3.49-4.37,4.92-6.03c1.43-1.66,2.48-2.51,5.59-3.7c3.11-1.19,8.26-2.73,11.54-3.66c3.28-0.93,4.68-1.26,5.29-0.92 c0.61,0.35,0.41,1.37-0.17,2.28c-0.58,0.9-1.55,1.68-3.54,2.59c-1.99,0.91-5,1.95-7.07,2.86c-2.07,0.9-3.2,1.67-3.93,2.47 c-0.73,0.81-1.06,1.65-1,2.18c0.06,0.53,0.52,0.74,1.92,0.45c1.4-0.29,3.74-1.08,6.1-1.67c2.36-0.59,4.73-0.98,7.02-1.29 c2.29-0.32,4.49-0.56,6.35-0.64c1.86-0.08,3.38,0,4.15,0.29c0.77,0.28,0.8,0.77,0.46,1.3c-0.34,0.53-1.04,1.09-2.46,1.5 c-1.41,0.41-3.53,0.66-5.8,1.18c-2.27,0.52-4.69,1.3-6.57,1.94c-1.88,0.64-3.22,1.14-4.05,1.73c-0.83,0.59-1.14,1.28-0.63,1.7 c0.52,0.42,1.87,0.56,3.71,0.64c1.84,0.08,4.17,0.09,6.49,0.26c2.32,0.17,4.61,0.5,6.5,0.94c1.88,0.45,3.35,1.01,4.26,1.51 c0.91,0.5,1.27,0.94,1.1,1.41c-0.17,0.46-0.87,0.95-2.17,1.13c-1.31,0.18-3.22,0.05-5.13-0.15c-1.91-0.21-3.81-0.49-5.57-0.6 c-1.76-0.11-3.38-0.04-4.81,0.16c-1.43,0.21-2.68,0.56-3.44,0.92c-0.76,0.36-1.04,0.73-1.04,1.01c0.01,0.28,0.31,0.48,1.52,0.85 c1.21,0.37,3.32,0.92,5.47,1.52c2.15,0.59,4.33,1.23,6.4,1.82c2.07,0.59,4.02,1.12,4.97,1.66c0.95,0.55,0.89,1.1,0.4,1.53 c-0.49,0.43-1.41,0.73-3.18,0.74c-1.77,0.01-4.4-0.27-6.58-0.51c-2.19-0.24-3.94-0.43-5.97-0.57c-2.04-0.14-4.36-0.23-6.53,0.46 c-2.17,0.69-4.18,2.16-6.56,3.39s-5.15,2.22-8.29,2.97c-3.14,0.75-6.65,1.25-9.48,0.95c-2.82-0.31-4.96-1.42-8.09-3.69 c-3.13-2.27-7.27-5.7-10.72-8.72c-3.45-3.03-6.23-5.66-7.97-7.42c-1.74-1.76-2.45-2.64-2.64-3.14c-0.19-0.5,0.15-0.63,0.84-0.35 c0.69,0.28,1.75,0.95,3.51,2.47c1.77,1.52,4.25,3.88,6.82,6.17c2.57,2.29,5.23,4.51,7.08,5.63c1.85,1.13,2.89,1.16,4.24,0.58 c1.35-0.58,3.01-1.77,4.17-2.89c1.17-1.12,1.84-2.17,2.2-3.22c0.35-1.05,0.39-2.09,0.25-3.03c-0.14-0.94-0.45-1.78-0.73-2.57 C212.35,294.91,212.11,294.16,212.46,294.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118369527150897803470000006486467553596840103_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.8159,
    y1: 335.6442,
    x2: 236.5773,
    y2: 335.6442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#EE2529"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000118369527150897803470000006486467553596840103_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M224.7,315.55c-1.88,1.36-4.44,3.2-6.6,4.36c-2.16,1.16-3.92,1.64-5.12,1.92c-1.2,0.28-1.84,0.36-2.56,1.36 c-0.72,1-1.52,2.92-2.56,5.92c-1.04,3-2.32,7.08-3.08,10.88c-0.76,3.8-1,7.32-0.96,10c0.04,2.68,0.36,4.52,0.72,6 c0.36,1.48,0.76,2.6,1.08,3.08c0.32,0.48,0.56,0.32,0.64-0.92c0.08-1.24,0-3.56,0.24-6.28c0.24-2.72,0.8-5.84,1.64-8.72 c0.84-2.88,1.96-5.52,3.56-8.44c1.6-2.92,3.68-6.12,5.88-8.88c2.2-2.76,4.52-5.08,6.72-6.84c2.2-1.76,4.28-2.96,6.36-3.88 c2.08-0.92,4.16-1.56,5.16-2.04c1-0.48,0.92-0.8,0.28-0.96c-0.64-0.16-1.84-0.16-3.12-0.08c-1.28,0.08-2.64,0.24-3.92,0.76 C227.78,313.31,226.58,314.19,224.7,315.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073706529648121017130000015705596461256142014_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.3589,
    y1: 426.3235,
    x2: 221.632,
    y2: 426.3235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#0B8040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000073706529648121017130000015705596461256142014_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M213.94,391.87c-0.16,2.72-0.48,7.84-0.56,12.96c-0.08,5.12,0.08,10.24,0.28,14.68c0.2,4.44,0.44,8.2,0.64,12.68 c0.2,4.48,0.36,9.68,0.52,15.28c0.16,5.6,0.32,11.6,0.56,14.6c0.24,3,0.56,3,1.04,0.36c0.48-2.64,1.12-7.92,1.92-14.04 c0.8-6.12,1.76-13.08,2.4-18.2c0.64-5.12,0.96-8.4,0.88-12.28c-0.08-3.88-0.56-8.36-1.4-12.52c-0.84-4.16-2.04-8-2.96-10.88 c-0.92-2.88-1.56-4.8-2.04-5.64c-0.48-0.84-0.8-0.6-0.96-0.32C214.1,388.83,214.1,389.15,213.94,391.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085220355362886043740000011202569688580543897_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.5269,
    y1: 474.8624,
    x2: 267.9424,
    y2: 474.8624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000085220355362886043740000011202569688580543897_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M232.1,466.14c-0.96,1.72-1.68,5.48-1.56,7.48c0.12,2,1.08,2.24,2.52,3.04c1.44,0.8,3.36,2.16,4.64,3.96 c1.28,1.8,1.92,4.04,2.12,5.92c0.2,1.88-0.04,3.4-0.4,4.6s-0.84,2.08-0.68,3.2c0.16,1.12,0.96,2.48,2.24,3.96 c1.28,1.48,3.04,3.08,4.2,4.88c1.16,1.8,1.72,3.8,2.12,5c0.4,1.2,0.64,1.6,1.36,0c0.72-1.6,1.92-5.2,3.12-9.56 c1.2-4.36,2.4-9.48,3.48-14.6c1.08-5.12,2.04-10.24,3.6-15.4c1.56-5.16,3.72-10.36,5.4-15c1.68-4.64,2.88-8.72,3.4-10.96 c0.52-2.24,0.36-2.64-0.8-1.72c-1.16,0.92-3.32,3.16-5.44,5.08s-4.2,3.52-5.96,4.72c-1.76,1.2-3.2,2-4.76,3.64 c-1.56,1.64-3.24,4.12-4.64,5.88c-1.4,1.76-2.52,2.8-4.24,3.48c-1.72,0.68-4.04,1-5.8,1C234.26,464.75,233.06,464.43,232.1,466.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052822380788778437230000013889017590611550640_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.9302,
    y1: 348.5479,
    x2: 282.6935,
    y2: 348.5479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    style: {
      stopColor: "#1F1F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#A9CF38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000052822380788778437230000013889017590611550640_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M259.78,388.23c1.28,0.12,3.12,0.44,4.96,1.08c1.84,0.64,3.68,1.6,5.36,3.24c1.68,1.64,3.2,3.96,4.08,4.48 c0.88,0.52,1.12-0.76,2.32-7.2c1.2-6.44,3.36-18.04,4.64-29.72c1.28-11.68,1.68-23.44,1.52-31.92c-0.16-8.48-0.88-13.68-1.48-18.16 c-0.6-4.48-1.08-8.24-2.4-9.52c-1.32-1.28-3.48-0.08-6.48,1.52c-3,1.6-6.84,3.6-10.73,5.27c-3.89,1.67-7.83,3-10.21,3.72 c-2.38,0.72-3.2,0.83-3.39,1.24c-0.19,0.41,0.25,1.13,2.11,2.05c1.86,0.92,5.14,2.04,7.86,3.88c2.72,1.84,4.88,4.4,6.76,7.28 c1.88,2.88,3.48,6.08,4.6,9.76c1.12,3.68,1.76,7.84,2.04,11.72c0.28,3.88,0.2,7.48-0.28,11.28c-0.48,3.8-1.36,7.8-2.52,11.36 c-1.16,3.56-2.6,6.68-4.2,9.2c-1.6,2.52-3.36,4.44-4.6,5.92c-1.24,1.48-1.96,2.52-1.96,3C257.78,388.19,258.5,388.11,259.78,388.23z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106131213301012610350000004651899270482115225_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.5527,
    y1: 584.7029,
    x2: 302.7714,
    y2: 584.7029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#92C83E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7112,
    style: {
      stopColor: "#75C593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000106131213301012610350000004651899270482115225_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M238.46,572.66c-0.68,1.6-1.24,4.72-2.04,7.4c-0.8,2.68-1.84,4.92-2.64,6.96c-0.8,2.04-1.36,3.88-1.2,5.52 c0.16,1.64,1.04,3.08,2.6,4.08c1.56,1,3.8,1.56,6.72,1.72c2.92,0.16,6.52-0.08,9.76-0.36c3.24-0.28,6.12-0.6,9.08-0.52 c2.96,0.08,6,0.56,9.56,0.72c3.56,0.16,7.64,0,11.76-0.16s8.28-0.32,11.44-0.4c3.16-0.08,5.32-0.08,6.72-0.48 c1.4-0.4,2.04-1.2,2.36-1.96c0.32-0.76,0.32-1.48-0.64-2.24c-0.96-0.76-2.88-1.56-5.24-2.04c-2.36-0.48-5.16-0.64-7.52-0.88 c-2.36-0.24-4.28-0.56-6.48-1.52c-2.2-0.96-4.68-2.56-7.52-4.48c-2.84-1.92-6.04-4.16-8.52-6.48c-2.48-2.32-4.24-4.72-5.32-5.8 c-1.08-1.08-1.48-0.84-1.56-0.12c-0.08,0.72,0.16,1.92,0.12,3.4c-0.04,1.48-0.36,3.24-1.04,4.72c-0.68,1.48-1.72,2.68-3.28,3.64 c-1.56,0.96-3.64,1.68-5.72,1.6c-2.08-0.08-4.16-0.96-5.8-2.24c-1.64-1.28-2.84-2.96-3.4-4.56c-0.56-1.6-0.48-3.12-0.36-4.32 c0.12-1.2,0.28-2.08-0.04-2.48C239.94,570.99,239.14,571.07,238.46,572.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131332817901100655820000015810179262216002985_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.6919,
    y1: 423.7607,
    x2: 285.6483,
    y2: 423.7607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#0B8040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#2A3185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#6CBE45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000131332817901100655820000015810179262216002985_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M282.06,372.43c-1.32,9.52-3.8,23.6-6.24,37.8c-2.44,14.2-4.84,28.52-8.04,41.76c-3.2,13.24-7.2,25.4-9.44,32.2 c-2.24,6.8-2.72,8.24-2.64,8.96c0.08,0.72,0.72,0.72,2.16,0.68c1.44-0.04,3.68-0.12,5.32-0.2c1.64-0.08,2.68-0.16,3.76-2.36 c1.08-2.2,2.2-6.52,3.56-11.56c1.36-5.04,2.96-10.8,4.2-14.92c1.24-4.12,2.12-6.6,2.36-9.52c0.24-2.92-0.16-6.28,0.44-9.8 c0.6-3.52,2.2-7.2,3.76-13.92c1.56-6.72,3.08-16.48,3.8-26.92s0.64-21.56,0.48-30.28c-0.16-8.72-0.4-15.04-0.72-18.2 c-0.32-3.16-0.72-3.16-1-0.68C283.54,357.95,283.38,362.91,282.06,372.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116935087572968407480000001040553099464385211_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.4717,
    y1: 247.3751,
    x2: 234.6864,
    y2: 247.3751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#3853A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#C3D82E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#BF2026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#8CD5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#EE2529"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000116935087572968407480000001040553099464385211_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M208.82,206.79c-0.72,0.84-0.24,3.56,0.68,8.76c0.92,5.2,2.28,12.88,4.16,20.44c1.88,7.56,4.28,15,6.08,21.52 c1.8,6.52,3,12.12,2.92,17.08c-0.08,4.96-1.44,9.28-1.96,11.52c-0.52,2.24-0.2,2.4,0.36,2c0.56-0.4,1.36-1.36,2.5-2.79 c1.14-1.43,2.62-3.32,4.5-4.84c1.88-1.52,4.16-2.67,5.42-3.76c1.26-1.09,1.5-2.13,0.86-2.45c-0.64-0.32-2.16,0.08-2.68-0.52 c-0.52-0.6-0.04-2.2-0.49-4.19c-0.45-1.99-1.82-4.37-3.18-6.69c-1.36-2.32-2.7-4.58-3.58-6.39c-0.87-1.81-1.27-3.17-0.59-4.21 c0.68-1.04,2.44-1.76,2.4-3c-0.04-1.24-1.88-3-3.76-5.28c-1.88-2.28-3.8-5.08-5.24-9c-1.44-3.92-2.4-8.96-2.4-13.4 c0-4.44,0.96-8.28,0.88-10.44c-0.08-2.16-1.2-2.64-2.72-3.4C211.46,206.99,209.54,205.95,208.82,206.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110459568918559231630000014017652345989902264_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.7088,
    y1: 195.943,
    x2: 286.5797,
    y2: 195.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#404099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7737,
    style: {
      stopColor: "#4054A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#534099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000110459568918559231630000014017652345989902264_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M213.27,151.1c2.48-0.88,6.93-1.86,10.72-2.63c3.79-0.77,6.91-1.33,8.87-2.13c1.96-0.8,2.76-1.84,4.17-1.76 c1.4,0.08,3.41,1.28,6.57,2.76c3.16,1.48,7.47,3.24,11.58,4.56c4.11,1.32,8.02,2.2,10.83,2.64c2.81,0.44,4.51,0.44,4.71,1.24 c0.2,0.8-1.1,2.4-1.35,3.8c-0.25,1.4,0.55,2.6,1.91,4.68c1.35,2.08,3.26,5.04,5.72,9.8c2.46,4.76,5.47,11.32,7.27,17.12 c1.81,5.8,2.41,10.84,2.31,13.92c-0.1,3.08-0.9,4.2-1.3,6.52c-0.4,2.32-0.4,5.84-0.5,10.56c-0.1,4.72-0.3,10.64-0.55,14.36 c-0.25,3.72-0.55,5.24-1.41,6c-0.85,0.76-2.26,0.76-4,0.92c-1.74,0.16-3.82,0.48-8.02,1.4c-4.2,0.92-10.52,2.44-13.04,2.44 c-2.52,0-1.24-1.52,0.28-3.52c1.52-2,3.28-4.48,4.8-7.68c1.52-3.2,2.8-7.12,3.48-11.52c0.68-4.4,0.76-9.28,0.4-12.68 c-0.36-3.4-1.16-5.32-0.36-6.72c0.8-1.4,3.2-2.28,5.48-4.24c2.28-1.96,4.44-5,4.88-9c0.44-4-0.84-8.96-2.76-12.48 c-1.92-3.52-4.48-5.6-7.28-6.44c-2.8-0.84-5.84-0.44-8.24-1.44c-2.4-1-4.16-3.4-5.76-6.08c-1.6-2.68-3.04-5.64-4.6-6.28 c-1.56-0.64-3.24,1.04-4.4,2c-1.16,0.96-1.8,1.2-4.24-0.52c-2.44-1.72-6.68-5.4-10.94-7.28c-4.26-1.88-8.54-1.96-11.66-1.64 c-3.12,0.32-5.08,1.04-5.81,1.01C210.29,152.76,210.79,151.98,213.27,151.1z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M507.95,99.5c2.07,0.22,3.57,2.09,3.34,4.16c-0.22,2.07-2.08,3.57-4.16,3.34c-2.07-0.22-3.57-2.09-3.34-4.16 C504.01,100.78,505.88,99.28,507.95,99.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9186 -0.3953 0.3953 0.9186 -4.3084 205.737)",
    className: "st47",
    cx: 497.15,
    cy: 113.32,
    rx: 3.77,
    ry: 3.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M532.08,95.95c0.44,1.53,2.23,4.83,3.33,7.79c1.1,2.97,1.51,5.6,1.55,8.48c0.04,2.88-0.3,6.01-0.95,9.1 c-0.65,3.09-1.61,6.15-2.93,8.63c-1.31,2.48-2.97,4.39-4.72,6.22c-1.75,1.83-3.58,3.6-5.69,4.98c-2.11,1.38-4.5,2.39-7.13,3.09 c-2.64,0.7-5.52,1.08-8.3,1.28c-2.77,0.21-5.43,0.23-7.75-0.02c-2.31-0.25-4.28-0.78-5.63-1.18c-1.35-0.4-2.08-0.67-2.58-0.69 c-0.5-0.02-0.78,0.2-0.83,0.67c-0.05,0.47,0.12,1.18,1.32,2.13c1.19,0.95,3.41,2.14,6.07,2.9c2.67,0.76,5.79,1.1,8.96,1.1 c3.16-0.01,6.36-0.36,9.49-1.16c3.12-0.8,6.17-2.05,8.8-3.63c2.64-1.58,4.87-3.49,6.87-5.58c2-2.09,3.76-4.37,5.11-6.59 c1.35-2.23,2.28-4.4,3.05-6.88c0.77-2.48,1.39-5.26,1.73-7.84c0.34-2.59,0.41-4.98,0.01-7.4c-0.4-2.42-1.28-4.85-2.33-7.15 c-1.05-2.3-2.27-4.45-3.3-5.99c-1.04-1.54-1.89-2.45-2.77-3.02C532.57,94.64,531.65,94.42,532.08,95.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M494.51,97.79c2.07,0.22,3.57,2.09,3.35,4.16c-0.22,2.07-2.09,3.57-4.16,3.35c-2.07-0.22-3.57-2.09-3.34-4.16 C490.58,99.06,492.44,97.57,494.51,97.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M521.95,169.18c-2.08,0.6-4.72,1.4-7.4,3.72c-2.68,2.32-5.4,6.16-7.47,10.37c-2.07,4.21-3.5,8.79-4.71,11.79 c-1.21,3-2.19,4.41-4.76,7.91c-2.57,3.51-6.73,9.11-9.27,13.87c-2.54,4.77-3.46,8.7-5.02,13.22c-1.55,4.52-3.74,9.64-4.95,12.2 c-1.21,2.56-1.45,2.56-1.45,1.76c0-0.8,0.24-2.4,0.84-7.6c0.6-5.2,1.56-14,3.2-22.28c1.64-8.28,3.96-16.04,6.52-22.04 c2.56-6,5.36-10.24,7.8-13.64c2.44-3.4,4.52-5.96,5.88-7.84c1.36-1.88,2-3.08,1.88-5.24c-0.12-2.16-1-5.28-2.52-7.6 c-1.52-2.32-3.68-3.84-4.36-4.44c-0.68-0.6,0.12-0.28,2.04,0.4c1.92,0.68,4.96,1.72,8.08,2.2c3.12,0.48,6.33,0.4,9.53-0.32 s6.39-2.08,8.99-3.28c2.6-1.2,4.6-2.24,6.32-3.4c1.72-1.16,3.16-2.44,3.72-1.84c0.56,0.6,0.24,3.08,1,5.68 c0.76,2.6,2.6,5.32,4.12,7.56c1.52,2.24,2.72,4,3.08,5c0.36,1-0.12,1.24-1.6,1.4c-1.48,0.16-3.96,0.24-6.52,0.4 c-2.56,0.16-5.2,0.4-7.28,0.72C525.55,168.18,524.03,168.58,521.95,169.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M473.07,247.26c-1.76,0.2-4.72,0.68-7.56,1.64c-2.84,0.96-5.56,2.4-7.4,4.4c-1.84,2-2.8,4.56-3.2,7.6 c-0.4,3.04-0.24,6.56,0.6,8.88c0.84,2.32,2.36,3.44,3.48,4c1.12,0.56,1.84,0.56,2.64-0.24c0.8-0.8,1.68-2.4,2.96-4.48 c1.28-2.08,2.96-4.64,4.56-7.52c1.6-2.88,3.12-6.08,4.24-8.52c1.12-2.44,1.84-4.12,1.92-5 C475.39,247.14,474.83,247.06,473.07,247.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M465.47,246.34c0.8-1.44,3.12-4.48,5.6-7.84c2.48-3.36,5.12-7.04,6.52-8.76c1.4-1.72,1.56-1.48,1.04,1.36 c-0.52,2.84-1.72,8.28-2.48,11.08c-0.76,2.8-1.08,2.96-2.68,3.4c-1.6,0.44-4.48,1.16-6.28,1.6 C465.39,247.62,464.67,247.78,465.47,246.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M547.09,342.32c0.61,1.84,0.62,4.25,0.34,11.21c-0.28,6.96-0.85,18.47-0.37,18.55 c0.48,0.08,2.01-11.27,2.86-18.39c0.85-7.12,1.01-10,1.2-11.96c0.19-1.96,0.42-3.01,0.18-3.42c-0.25-0.4-0.97-0.16-2.25-0.12 c-1.28,0.04-3.12-0.12-3.44,0.44C545.28,339.2,546.48,340.48,547.09,342.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M533.77,416.16c0.12,1.22-0.05,2.8-0.2,3.58c-0.15,0.78-0.27,0.78-0.56,0.1c-0.28-0.69-0.73-2.06-1.53-3.64 c-0.8-1.57-1.96-3.35-3.25-4.92c-1.28-1.57-2.69-2.92-4.25-4.04c-1.56-1.12-3.28-2-4.74-2.69c-1.46-0.69-2.68-1.18-3.91-1.48 c-1.23-0.3-2.49-0.4-3.55-0.42c-1.06-0.02-1.92,0.05-2.27-0.05c-0.35-0.1-0.18-0.36,0.72-0.76c0.9-0.4,2.55-0.92,3.95-1.08 c1.4-0.16,2.57,0.06,4.14,0.56c1.57,0.5,3.56,1.3,5.47,2.47c1.92,1.17,3.76,2.73,5.26,4.35c1.49,1.63,2.63,3.32,3.4,4.61 C533.24,414.05,533.65,414.93,533.77,416.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M508.03,454.54c-0.38,0.27-1.4,0.77-2.35,1.14c-0.95,0.37-1.84,0.62-3.18,0.54c-1.33-0.08-3.1-0.48-4.9-1.16 c-1.8-0.68-3.63-1.65-5.31-2.69c-1.68-1.04-3.22-2.14-4.52-3.5c-1.3-1.35-2.36-2.95-3.01-4.32c-0.65-1.37-0.89-2.51-0.88-3.7 c0.02-1.19,0.3-2.41,0.52-3.03c0.22-0.62,0.39-0.63,0.64,0.03c0.25,0.66,0.59,1.98,1.23,3.44c0.64,1.46,1.57,3.05,2.64,4.4 c1.06,1.34,2.26,2.43,3.6,3.45c1.34,1.02,2.83,1.98,4.49,2.75c1.66,0.77,3.49,1.36,5.05,1.74c1.56,0.38,2.83,0.56,3.76,0.62 c0.92,0.06,1.5,0,1.91-0.01C508.14,454.23,508.41,454.27,508.03,454.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M512.05,406.6c0.55,0.28,1.52,0.94,1.98,1.38c0.46,0.44,0.41,0.67,0.08,0.9c-0.33,0.23-0.92,0.47-1.2,0.64 c-0.28,0.17-0.24,0.29,0.26,0.61c0.5,0.32,1.47,0.85,1.95,1.21c0.47,0.35,0.44,0.53,0.18,0.74c-0.27,0.21-0.78,0.46-1.11,0.55 s-0.48,0.01-0.97-0.34c-0.49-0.35-1.32-0.96-1.99-1.13c-0.66-0.17-1.16,0.12-1.34,0.41c-0.18,0.29-0.04,0.58,0.45,0.95 c0.5,0.37,1.35,0.81,1.74,1.1c0.39,0.3,0.31,0.45,0.13,0.65c-0.19,0.21-0.48,0.47-0.72,0.59c-0.24,0.12-0.41,0.09-1-0.29 c-0.59-0.38-1.58-1.11-2.15-1.39c-0.57-0.28-0.73-0.1-0.92,0.15c-0.19,0.25-0.42,0.58-0.54,0.87c-0.12,0.29-0.12,0.54,0.33,0.88 c0.45,0.34,1.34,0.77,1.76,1.08c0.42,0.31,0.35,0.5,0.18,0.7c-0.17,0.2-0.44,0.41-0.65,0.54c-0.21,0.13-0.36,0.18-0.92-0.12 c-0.56-0.3-1.53-0.96-2.09-1.26c-0.56-0.3-0.71-0.25-0.94,0.01c-0.23,0.26-0.54,0.74-0.67,1.06c-0.13,0.32-0.08,0.47,0.4,0.8 c0.48,0.33,1.41,0.83,1.83,1.18c0.43,0.35,0.36,0.54,0.21,0.78c-0.15,0.24-0.4,0.53-0.59,0.65c-0.19,0.12-0.33,0.08-0.8-0.25 c-0.47-0.33-1.26-0.96-1.79-1.24c-0.53-0.27-0.8-0.19-1.09,0.1c-0.29,0.28-0.6,0.76-0.71,1.07c-0.11,0.31-0.02,0.45,0.5,0.77 c0.52,0.32,1.48,0.81,1.97,1.16c0.49,0.35,0.51,0.55,0.42,0.73c-0.09,0.18-0.3,0.33-0.49,0.43c-0.2,0.11-0.39,0.17-0.92-0.12 c-0.54-0.29-1.42-0.93-1.95-1.21c-0.53-0.27-0.71-0.17-0.96,0.1c-0.25,0.27-0.57,0.71-0.67,1.06s0.03,0.6,0.5,0.89 c0.47,0.29,1.29,0.62,1.75,0.85c0.45,0.23,0.54,0.37,0.45,0.68c-0.09,0.3-0.36,0.77-0.59,1.03c-0.23,0.26-0.42,0.33-0.98,0.04 c-0.56-0.28-1.47-0.92-2.02-1.18c-0.55-0.27-0.73-0.17-0.92,0.02c-0.19,0.19-0.4,0.47-0.43,0.69c-0.03,0.22,0.1,0.39,0.65,0.72 c0.55,0.33,1.51,0.82,2.02,1.16c0.51,0.34,0.57,0.53,0.45,0.82c-0.12,0.29-0.41,0.68-0.62,0.87c-0.21,0.19-0.34,0.19-0.84-0.11 c-0.5-0.3-1.37-0.91-1.9-1.18c-0.53-0.27-0.72-0.21-0.95,0.07c-0.22,0.28-0.48,0.79-0.57,1.11c-0.09,0.32,0,0.46,0.53,0.8 c0.53,0.34,1.5,0.86,2,1.19c0.5,0.32,0.54,0.44,0.45,0.68c-0.09,0.24-0.31,0.61-0.51,0.84c-0.2,0.23-0.38,0.33-0.89,0.1 c-0.52-0.23-1.37-0.8-1.87-1.08c-0.49-0.28-0.62-0.29-0.77,0.02c-0.16,0.3-0.34,0.91-0.35,1.33c-0.01,0.42,0.15,0.67,0.73,1.01 c0.57,0.34,1.56,0.78,2.02,1.1c0.46,0.32,0.39,0.5,0.25,0.72c-0.14,0.21-0.36,0.45-0.95,0.31c-0.59-0.15-1.57-0.68-2.15-0.91 c-0.58-0.23-0.77-0.17-0.93,0.07c-0.15,0.24-0.27,0.66-0.26,0.95c0.01,0.29,0.15,0.46,0.72,0.8c0.57,0.34,1.58,0.86,2.1,1.28 c0.52,0.42,0.54,0.75,0.4,1.05c-0.14,0.3-0.43,0.56-1.05,0.4c-0.62-0.16-1.56-0.74-2.14-1.02c-0.57-0.28-0.78-0.26-0.93-0.08 c-0.15,0.18-0.26,0.5-0.69,0.47c-0.43-0.03-1.19-0.42-1.59-0.69c-0.4-0.27-0.45-0.42-0.42-0.77c0.04-0.35,0.16-0.89,0.22-1.23 c0.06-0.34,0.06-0.46-0.52-0.82c-0.58-0.36-1.74-0.96-2.33-1.27c-0.59-0.32-0.6-0.35-0.54-0.69c0.06-0.34,0.19-0.97,0.37-1.28 c0.17-0.31,0.39-0.29,0.93,0.08c0.54,0.37,1.41,1.1,1.96,1.43c0.55,0.33,0.78,0.26,1.01-0.01c0.23-0.26,0.46-0.72,0.55-1.04 c0.09-0.32,0.02-0.51-0.61-0.9c-0.63-0.39-1.83-0.97-2.52-1.4c-0.69-0.43-0.86-0.71-0.85-1.07c0.01-0.36,0.2-0.8,0.38-1.05 c0.17-0.25,0.33-0.29,0.94,0.05c0.62,0.35,1.7,1.1,2.35,1.48c0.65,0.38,0.86,0.4,1.01,0.24c0.14-0.15,0.21-0.47,0.27-0.74 c0.06-0.27,0.11-0.5-0.48-0.98c-0.6-0.48-1.85-1.22-2.48-1.69c-0.64-0.47-0.66-0.67-0.54-0.94c0.12-0.27,0.39-0.61,0.61-0.79 c0.22-0.18,0.38-0.19,0.96,0.17c0.58,0.36,1.57,1.09,2.13,1.46c0.56,0.37,0.69,0.37,0.93,0.08c0.24-0.29,0.6-0.87,0.76-1.24 c0.16-0.37,0.11-0.52-0.54-0.9c-0.65-0.38-1.9-0.99-2.54-1.41s-0.68-0.67-0.58-0.95c0.1-0.28,0.33-0.61,0.53-0.78 c0.2-0.17,0.36-0.18,0.99,0.21c0.63,0.39,1.73,1.17,2.39,1.55c0.67,0.37,0.91,0.34,1.11,0.11c0.2-0.23,0.36-0.66,0.41-0.95 c0.05-0.29,0-0.44-0.64-0.87c-0.64-0.43-1.88-1.12-2.52-1.55c-0.64-0.42-0.69-0.58-0.56-0.83c0.13-0.25,0.44-0.6,0.67-0.79 c0.24-0.18,0.4-0.19,1.01,0.2c0.61,0.39,1.67,1.19,2.27,1.56c0.6,0.37,0.76,0.32,1.01,0.07c0.26-0.25,0.62-0.7,0.76-1.04 c0.14-0.34,0.07-0.57-0.58-1.01c-0.65-0.44-1.87-1.1-2.51-1.53c-0.64-0.42-0.7-0.62-0.6-0.88c0.1-0.27,0.37-0.6,0.62-0.75 c0.25-0.14,0.48-0.09,1.12,0.35c0.65,0.44,1.72,1.28,2.32,1.7c0.6,0.42,0.72,0.42,0.98,0.23c0.26-0.19,0.64-0.56,0.8-0.87 c0.15-0.3,0.08-0.53-0.55-0.98s-1.81-1.12-2.44-1.55c-0.62-0.43-0.68-0.62-0.51-0.93c0.17-0.31,0.58-0.74,0.88-0.94 c0.29-0.2,0.47-0.17,1.08,0.26c0.6,0.44,1.64,1.28,2.25,1.74c0.61,0.46,0.8,0.52,1.12,0.35c0.33-0.17,0.79-0.57,1.02-0.88 c0.24-0.31,0.25-0.52-0.36-1c-0.62-0.48-1.86-1.21-2.54-1.67c-0.67-0.46-0.77-0.64-0.61-0.9c0.17-0.26,0.6-0.62,0.91-0.76 c0.31-0.14,0.5-0.08,1.06,0.35c0.56,0.43,1.49,1.23,2.07,1.65c0.58,0.42,0.81,0.48,1.18,0.32c0.37-0.16,0.88-0.54,1.12-0.76 c0.24-0.23,0.22-0.3-0.4-0.73c-0.62-0.43-1.85-1.22-2.49-1.72c-0.65-0.51-0.72-0.74-0.53-0.99c0.19-0.25,0.65-0.53,0.98-0.63 c0.32-0.1,0.51-0.04,1.04,0.36c0.53,0.4,1.4,1.13,1.94,1.5c0.54,0.37,0.76,0.39,1.15,0.22c0.39-0.17,0.95-0.52,1.21-0.77 c0.26-0.25,0.21-0.4-0.3-0.74c-0.51-0.34-1.48-0.87-2-1.23c-0.52-0.36-0.58-0.55-0.39-0.76c0.19-0.21,0.62-0.43,0.91-0.52 s0.43-0.05,0.88,0.33c0.46,0.38,1.24,1.1,1.72,1.49c0.48,0.39,0.67,0.46,1.03,0.32c0.36-0.14,0.88-0.47,1.21-0.68 C511.36,406.4,511.5,406.31,512.05,406.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M486.12,459.2c0.04,2.64,1.64,9.2,2.56,11.68c0.92,2.48,1.16,0.88,1.36-0.8c0.2-1.68,0.36-3.44,1.2-4.92 c0.84-1.48,2.36-2.68,4-4c1.64-1.32,3.4-2.76,4.22-3.67c0.82-0.91,0.69-1.29-0.15-1.21c-0.84,0.08-2.39,0.62-3.89,1.09 c-1.5,0.47-2.94,0.87-3.98,1.15c-1.04,0.28-1.68,0.44-2.76-0.12C487.6,457.84,486.08,456.56,486.12,459.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M536.31,481.42c-0.68,1.64-1.72,5.88-3.69,9.64c-1.97,3.76-4.86,7.03-4.78,9.46 c0.08,2.43,3.13,4.03,4.29,6.91c1.16,2.88,0.43,7.05,1.23,9.33c0.8,2.28,3.12,2.68,4.84,5.45c1.73,2.76,2.86,7.89,3.54,10.26 c0.69,2.36,0.93,1.96,1.09-0.48c0.16-2.44,0.24-6.92,0.24-11.68c0-4.76-0.08-9.8-0.72-15.04c-0.64-5.24-1.84-10.68-2.72-14.64 c-0.88-3.96-1.44-6.44-1.88-8.16C537.31,480.74,536.99,479.78,536.31,481.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M507.99,616.18c-2.6,1.6-7.24,5.2-11.88,8.68c-4.64,3.48-9.28,6.84-13,9.12c-3.72,2.28-6.52,3.48-9.96,4.64 c-3.44,1.16-7.52,2.28-10.92,3.16c-3.4,0.88-6.12,1.52-7.56,2.72c-1.44,1.2-1.6,2.96-1.92,4.04c-0.32,1.08-0.8,1.48-1.04,2.12 c-0.24,0.64-0.24,1.52,0.84,2.48c1.08,0.96,3.24,2,7.48,3.12c4.24,1.12,10.56,2.32,16.84,2.92c6.28,0.6,12.52,0.6,17.2,0.32 c4.68-0.28,7.8-0.84,10.84-1.76c3.04-0.92,6-2.2,8.56-3.08c2.56-0.88,4.72-1.36,7.04-1.32c2.32,0.04,4.8,0.6,7.52,0.6 c2.72,0,5.68-0.56,8.28-1.24c2.6-0.68,4.84-1.48,5.84-2.36c1-0.88,0.76-1.84,0.72-3.52c-0.04-1.68,0.12-4.08,0.12-7.04 c0-2.96-0.16-6.48-0.64-9c-0.48-2.52-1.28-4.04-1.88-5.56c-0.6-1.52-1-3.04-1.28-4.44c-0.28-1.4-0.44-2.68-0.64-3 c-0.2-0.32-0.44,0.32-1.24,1.56c-0.8,1.24-2.16,3.08-3.92,4.44c-1.76,1.36-3.92,2.24-6.2,2.72c-2.28,0.48-4.68,0.56-6.8-0.2 s-3.96-2.36-5.36-4.32c-1.4-1.96-2.36-4.28-3.12-5.64C511.15,614.98,510.59,614.58,507.99,616.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M498.75,550.1c0.08,2.96,0.4,9.28,0.6,14.08c0.2,4.8,0.28,8.08,0.12,10.28c-0.16,2.2-0.56,3.32-3.84,6.44 c-3.28,3.12-9.44,8.24-13.88,11.24c-4.44,3-7.16,3.88-10.32,4.56c-3.16,0.68-6.76,1.16-9.8,1.64c-3.04,0.48-5.52,0.96-7.28,1.6 c-1.76,0.64-2.8,1.44-3.44,2.56c-0.64,1.12-0.88,2.56-1.16,3.28c-0.28,0.72-0.6,0.72-0.84,1c-0.24,0.28-0.4,0.84-0.32,1.32 c0.08,0.48,0.4,0.88,1.28,1.28c0.88,0.4,2.32,0.8,4.6,1.28c2.28,0.48,5.4,1.04,9.2,1.4c3.8,0.36,8.28,0.52,12.12,0.48 c3.84-0.04,7.04-0.28,10.08-0.76c3.04-0.48,5.92-1.2,8.8-1.52c2.88-0.32,5.76-0.24,8.44,0c2.68,0.24,5.16,0.64,6.56,0.72 c1.4,0.08,1.72-0.16,2.2-0.96c0.48-0.8,1.12-2.16,1.48-4.24c0.36-2.08,0.44-4.88,0.48-7.52c0.04-2.64,0.04-5.12-0.36-8.16 c-0.4-3.04-1.2-6.64-2.32-9.88c-1.12-3.24-2.56-6.12-4.24-9.92c-1.68-3.8-3.6-8.52-4.96-12.4c-1.36-3.88-2.16-6.92-2.64-8.64 C498.83,547.54,498.67,547.14,498.75,550.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M537.03,170.98c1.63,1.12,4.82,2.79,7.66,5.34c2.83,2.56,5.31,6,6.63,10.28c1.32,4.28,1.48,9.4,0.8,14.24 c-0.68,4.84-2.2,9.4-3.96,13.72c-1.76,4.32-3.76,8.4-5.44,11.04c-1.68,2.64-3.04,3.84-4.2,5.04c-1.16,1.2-2.12,2.4-3.96,4.56 c-1.84,2.16-4.56,5.28-5.72,6.84c-1.16,1.56-0.76,1.56,0.32,0.8c1.08-0.76,2.84-2.28,4.68-3.64c1.84-1.36,3.76-2.56,5.28-3.6 c1.52-1.04,2.64-1.92,3.56-2.08c0.92-0.16,1.64,0.4,3.71,1.73c2.07,1.33,5.48,3.43,7.76,4.71c2.28,1.28,3.42,1.74,4.24,2.17 c0.81,0.43,1.29,0.83,1.62-0.09c0.33-0.92,0.5-3.15,0.7-7.66c0.21-4.52,0.45-11.32,0.05-18.32c-0.4-7-1.44-14.2-2.72-20.04 c-1.28-5.84-2.8-10.32-4.68-14.68c-1.88-4.36-4.12-8.6-5.72-10.84c-1.6-2.24-2.56-2.48-4.52-2.44c-1.96,0.04-4.92,0.36-6.36,0.8 C535.31,169.3,535.39,169.86,537.03,170.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M544.69,383.16c-0.35,1.72-2.5,6.93-4.1,12.54c-1.59,5.6-2.63,11.6-3.28,14.8c-0.65,3.2-0.9,3.59-1.3,2.42 c-0.41-1.16-0.97-3.88-1.41-5.72c-0.44-1.84-0.76-2.8-1.68-3.08c-0.92-0.28-2.44,0.12-3.63,0.48c-1.19,0.36-2.06,0.68-2.58,0.56 c-0.52-0.13-0.69-0.7-1.38-3.78c-0.69-3.08-1.88-8.67-2.52-11.66c-0.64-2.99-0.72-3.39-0.92-4.02c-0.2-0.63-0.52-1.48,1.33-1.85 c1.86-0.37,5.89-0.26,9.41,0.01c3.52,0.27,6.53,0.69,8.76,0.02C543.6,383.2,545.04,381.44,544.69,383.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st74",
    cx: 508.8,
    cy: 119.52,
    rx: 35.33,
    ry: 34.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M529.15,91.21c0.99,0.56,2.14,1.15,2.72,2.11c0.57,0.96,0.57,2.29,0.35,3.53c-0.22,1.24-0.66,2.39-1.37,3.94 c-0.71,1.55-1.68,3.5-2.26,4.43c-0.58,0.93-0.75,0.84-1.77,0.4c-1.02-0.44-2.88-1.24-3.94-1.68c-1.06-0.44-1.33-0.53-0.97,2.35 c0.35,2.88,1.33,8.72,1.9,11.69c0.58,2.97,0.75,3.05,3.45,1.82c2.7-1.24,7.93-3.81,10.67-5.31c2.74-1.51,3.01-1.95,2.79-2.39 c-0.22-0.44-0.93-0.89-1.77-1.24c-0.84-0.35-1.82-0.62-2.3-0.8s-0.49-0.27,0-1.95c0.49-1.68,1.46-4.96,1.77-7.79 c0.31-2.83-0.04-5.22-1.06-7.13c-1.02-1.9-2.7-3.32-4.38-4.12c-1.68-0.8-3.36-0.97-4.67-0.9c-1.3,0.08-2.23,0.41-2.47,0.69 c-0.24,0.28,0.2,0.52,0.84,0.9C527.31,90.13,528.15,90.66,529.15,91.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M487.7,147.21c-0.97-0.59-2.1-1.23-2.64-2.21c-0.54-0.98-0.49-2.31-0.22-3.54c0.27-1.23,0.75-2.36,1.52-3.89 c0.77-1.52,1.81-3.43,2.42-4.34c0.61-0.91,0.78-0.81,1.78-0.33c1,0.48,2.83,1.35,3.88,1.83c1.05,0.48,1.31,0.58,1.06-2.31 c-0.25-2.89-1-8.77-1.47-11.75c-0.46-2.99-0.64-3.08-3.38-1.94c-2.74,1.14-8.06,3.51-10.86,4.91c-2.8,1.4-3.08,1.83-2.88,2.29 c0.2,0.45,0.9,0.92,1.72,1.3c0.83,0.39,1.79,0.69,2.27,0.88c0.48,0.2,0.48,0.28-0.07,1.95c-0.55,1.66-1.64,4.9-2.06,7.72 c-0.42,2.82-0.15,5.22,0.8,7.16c0.95,1.94,2.58,3.42,4.23,4.28c1.65,0.86,3.33,1.1,4.63,1.07c1.31-0.03,2.25-0.32,2.5-0.6 c0.25-0.27-0.18-0.53-0.81-0.93C489.5,148.36,488.68,147.81,487.7,147.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M519.08,102.56v6.54c-2.55-1.94-5.31-3.11-8.29-3.51v8.66c3.25,1.01,5.75,2.5,7.51,4.46 c1.76,1.97,2.64,4.09,2.64,6.34c0,2.6-0.88,4.81-2.63,6.61c-1.76,1.81-4.27,2.99-7.52,3.57v5.84h-4.46v-5.84 c-3.2-0.5-6.3-1.72-9.3-3.66v-6.28c3.23,2.47,6.33,3.96,9.3,4.46v-10.29c-6.45-1.51-9.67-4.9-9.67-10.17 c0-2.42,0.87-4.52,2.6-6.29c1.74-1.77,4.09-2.82,7.07-3.17v-1.91h4.46v1.91C513.36,99.97,516.12,100.86,519.08,102.56 L519.08,102.56z M506.33,112.65v-7.05c-2.37,0.59-3.56,1.73-3.56,3.42C502.77,110.67,503.96,111.88,506.33,112.65L506.33,112.65z  M510.79,120.93v8.74c2.73-0.63,4.09-2.03,4.09-4.2C514.88,123.4,513.52,121.88,510.79,120.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M529.52,330.28c0.14-2.94,0.56-8.49,0.86-11.41c0.29-2.92,0.45-3.21,0.72-3.45 c0.27-0.24,0.64-0.43,0.95-0.57c0.31-0.14,0.57-0.23,1.09-0.23c0.52,0,1.31,0.09,1.77,0.07c0.45-0.02,0.58-0.15,0.78-0.28 c0.2-0.13,0.49-0.28,0.83-0.41c0.34-0.14,0.74-0.27,1.75-0.24c1.02,0.03,2.65,0.21,3.44,0.42c0.79,0.2,0.75,0.42,0.69,0.96 c-0.06,0.55-0.13,1.42-0.18,2.01c-0.05,0.59-0.07,0.89,0.08,1.23c0.15,0.34,0.48,0.73,0.86,0.96c0.38,0.24,0.81,0.33,1.27,0.3 c0.46-0.03,0.94-0.19,1.25-0.38c0.32-0.19,0.47-0.43,0.59-0.82c0.11-0.39,0.19-0.93,0.24-1.6c0.05-0.67,0.09-1.46,0.18-1.84 c0.09-0.38,0.22-0.34,1.09-0.27c0.87,0.07,2.49,0.17,3.38,0.3c0.9,0.13,1.08,0.28,1.28,0.49c0.2,0.21,0.43,0.47,0.55,0.79 c0.13,0.31,0.15,0.67-0.04,3.78c-0.2,3.1-0.62,8.95-0.91,12.02c-0.29,3.07-0.45,3.36-0.68,3.62c-0.23,0.26-0.52,0.48-0.81,0.65 c-0.29,0.17-0.57,0.28-3.79,0.09c-3.22-0.19-9.36-0.69-12.58-1.03c-3.22-0.34-3.5-0.53-3.77-0.76c-0.27-0.23-0.52-0.5-0.72-0.8 C529.51,333.56,529.38,333.22,529.52,330.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M531.43,329.92c-0.19,2.71-0.13,2.96,0.02,3.14c0.15,0.18,0.39,0.28,0.73,0.35c0.34,0.07,0.77,0.1,0.99,0.11 c0.22,0,0.22-0.02,0.45-2.84c0.23-2.81,0.68-8.41,0.87-11.26c0.19-2.84,0.11-2.93,0.02-2.99c-0.09-0.06-0.2-0.1-0.45-0.1 c-0.25-0.01-0.63,0.02-0.89,0.07c-0.25,0.05-0.37,0.12-0.46,0.21c-0.09,0.09-0.15,0.19-0.41,2.83 C532.07,322.06,531.62,327.22,531.43,329.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M543.19,317.43c0.05-0.61,0.6-1.06,1.24-1.01c0.63,0.05,1.11,0.59,1.06,1.2c-0.05,0.61-0.6,1.06-1.24,1.01 C543.62,318.58,543.14,318.04,543.19,317.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 473.61,
    y: 236.09,
    transform: "matrix(0.481 -0.8767 0.8767 0.481 35.6721 563.5812)",
    className: "st79",
    width: 40.54,
    height: 31.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.35,
    y: 226.79,
    transform: "matrix(0.481 -0.8767 0.8767 0.481 57.262 562.8041)",
    className: "st22",
    width: 1.34,
    height: 12.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M501.92,230.63c0.06-0.15,0.14-0.3,0.27-0.44c0.13-0.14,0.29-0.25,0.53-0.32c0.24-0.07,0.56-0.1,0.88-0.08 c0.32,0.02,0.64,0.09,1.18,0.32c0.54,0.22,1.31,0.59,1.78,0.9c0.47,0.31,0.64,0.56,0.73,0.81c0.09,0.25,0.1,0.51,0.1,0.75 c0,0.23-0.01,0.43-0.05,0.61c-0.05,0.18-0.13,0.34-0.22,0.49c-0.09,0.16-0.17,0.31-1.06-0.12c-0.88-0.43-2.57-1.46-3.4-2.04 C501.84,230.92,501.86,230.78,501.92,230.63z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st80",
    points: "498.21,230.92 497.37,232.45 507.97,238.26 508.93,236.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 487.79,
    y1: 236.53,
    x2: 489.67,
    y2: 237.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 492.49,
    y1: 239.11,
    x2: 507.56,
    y2: 247.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 485.2,
    y1: 241.24,
    x2: 487.09,
    y2: 242.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 489.91,
    y1: 243.82,
    x2: 504.97,
    y2: 252.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 482.62,
    y1: 245.94,
    x2: 484.5,
    y2: 246.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 487.33,
    y1: 248.53,
    x2: 502.39,
    y2: 256.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 480.04,
    y1: 250.65,
    x2: 481.92,
    y2: 251.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 484.75,
    y1: 253.23,
    x2: 499.81,
    y2: 261.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "541.59,236.09 528.22,245.15 533.44,269.18 556.78,260.91 557.44,244.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "541.86,238.51 530.58,246.15 534.98,266.44 554.68,259.46 555.23,246.01  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M535.08,265.31l6.31-26.91l0.93,0.22l-6.31,26.91l-0.13,0.23L535.08,265.31L535.08,265.31z M535.88,265.76 l-1.18,1.17l0.38-1.62L535.88,265.76L535.88,265.76z M555.57,246.35l-19.69,19.41l-0.67-0.68l19.69-19.41L555.57,246.35z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st84",
    x1: 530.58,
    y1: 246.15,
    x2: 554.68,
    y2: 259.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st81",
    points: "546.42,254.9 548.09,243.07 538.85,250.72  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M501.67,333.31l-25.02-22.33c-1.46-1.31-1.59-3.57-0.29-5.04l33.02-37c1.31-1.46,3.57-1.59,5.04-0.29 l25.02,22.33c1.46,1.31,1.59,3.57,0.29,5.04l-33.02,37C505.4,334.49,503.14,334.61,501.67,333.31z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 508.84,
    y1: 330.63,
    x2: 512.04,
    y2: 333.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 508.46,
    y1: 330.52,
    x2: 504.34,
    y2: 326.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 513,
    y1: 325.97,
    x2: 516.2,
    y2: 328.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 512.62,
    y1: 325.86,
    x2: 508.49,
    y2: 322.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 517.04,
    y1: 321.45,
    x2: 520.23,
    y2: 324.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st88",
    x1: 516.66,
    y1: 321.34,
    x2: 512.53,
    y2: 317.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 521.2,
    y1: 316.79,
    x2: 524.39,
    y2: 319.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 520.82,
    y1: 316.68,
    x2: 516.69,
    y2: 313
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 525.35,
    y1: 312.13,
    x2: 528.55,
    y2: 314.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 524.97,
    y1: 312.02,
    x2: 520.85,
    y2: 308.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 529.39,
    y1: 307.6,
    x2: 532.59,
    y2: 310.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 529.01,
    y1: 307.5,
    x2: 524.89,
    y2: 303.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 533.55,
    y1: 302.94,
    x2: 536.74,
    y2: 305.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 533.17,
    y1: 302.84,
    x2: 529.04,
    y2: 299.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st86",
    x1: 537.71,
    y1: 298.29,
    x2: 540.9,
    y2: 301.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st87",
    x1: 537.32,
    y1: 298.18,
    x2: 533.2,
    y2: 294.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M508.84,338.34l30.98,0.24c3.41,0.03,6.17,2.84,6.15,6.24l-0.25,31.29c-0.03,3.41-2.84,6.17-6.24,6.15 l-30.98-0.24c-3.41-0.03-6.17-2.84-6.15-6.24l0.25-31.29C502.63,341.08,505.44,338.32,508.84,338.34z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "510.6,346.26 537.59,346.62 537.38,373.88 510.43,373.67 510.45,369.96 507.05,369.93  507.09,364.66 510.5,364.69 510.57,355.7 507.16,355.68 507.2,350.1 510.61,350.13  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M524.21,353.8c3.59,0.03,6.48,2.96,6.45,6.56c-0.03,3.59-2.96,6.48-6.56,6.45 c-3.59-0.03-6.48-2.96-6.45-6.56C517.69,356.66,520.62,353.77,524.21,353.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M524.19,356.9c1.88,0.01,3.4,1.55,3.38,3.43c-0.01,1.88-1.55,3.4-3.43,3.38c-1.88-0.01-3.4-1.55-3.38-3.43 C520.77,358.4,522.31,356.88,524.19,356.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M520.69,385.83l12.11,58.1c0.45,2.17-0.95,4.32-3.13,4.78l-38.34,7.99c-2.17,0.45-4.32-0.95-4.78-3.13 l-12.11-58.1c-0.45-2.17,0.95-4.32,3.13-4.78l38.34-7.99C518.09,382.25,520.24,383.66,520.69,385.83z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "525.1,406.98 532.6,405.41 535.94,421.42 528.43,422.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st94",
    points: "519.15,383.42 503.62,419.7 532.47,446.52  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M512.47,417.65c0.23,1.09-0.47,2.16-1.56,2.39c-1.09,0.23-2.16-0.47-2.39-1.56 c-0.23-1.09,0.47-2.16,1.56-2.39C511.18,415.86,512.25,416.56,512.47,417.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M517.01,575.76l20.31-0.34c1.16-0.02,2.13,0.92,2.15,2.08l0.51,30.25c0.02,1.16-0.92,2.13-2.08,2.15 l-20.31,0.34c-1.16,0.02-2.13-0.92-2.15-2.08l-0.51-30.25C514.91,576.75,515.85,575.78,517.01,575.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M519.38,591.17l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.02,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C518.33,591.67,518.8,591.18,519.38,591.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M519.49,597.2l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.02,1.48c0.01,0.58-0.46,1.07-1.04,1.08l-1.48,0.02 c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C518.44,597.69,518.9,597.21,519.49,597.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M519.59,603.34l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.02,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C518.54,603.83,519.01,603.35,519.59,603.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M526.68,591.05l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.03,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C525.63,591.54,526.1,591.06,526.68,591.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M526.78,597.08l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.03,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C525.73,597.57,526.2,597.09,526.78,597.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M526.89,603.21l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.03,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C525.84,603.71,526.3,603.22,526.89,603.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M534.09,590.93l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.02,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C533.04,591.42,533.51,590.93,534.09,590.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M534.19,596.95l1.48-0.02c0.58-0.01,1.07,0.46,1.08,1.04l0.03,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.03c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C533.14,597.45,533.61,596.96,534.19,596.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M534.29,603.09l1.48-0.03c0.58-0.01,1.07,0.46,1.08,1.04l0.03,1.48c0.01,0.58-0.46,1.07-1.04,1.08 l-1.48,0.02c-0.58,0.01-1.07-0.46-1.08-1.04l-0.02-1.48C533.24,603.58,533.71,603.1,534.29,603.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M519.18,578.9l16.08-0.27c0.58-0.01,1.07,0.46,1.08,1.04l0.13,7.62c0.01,0.58-0.46,1.07-1.04,1.08 l-16.08,0.27c-0.58,0.01-1.07-0.46-1.08-1.04l-0.13-7.62C518.13,579.4,518.6,578.91,519.18,578.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M470.69,367.23c-0.51-5.81-1.17-16.95-1.47-22.72c-0.3-5.78-0.24-6.2-0.11-6.66 c0.14-0.46,0.36-0.97,0.66-1.41c0.31-0.43,0.7-0.79,1.06-1.06c0.36-0.27,0.68-0.45,4.63-0.77c3.96-0.32,11.55-0.77,15.47-0.96 c3.92-0.19,4.17-0.12,4.38-0.05c0.21,0.07,0.38,0.14,0.64,0.38c0.26,0.23,0.62,0.63,0.93,1.02c0.31,0.4,0.59,0.79,1.07,6.81 c0.48,6.02,1.17,17.65,1.45,23.68c0.28,6.03,0.13,6.45-0.17,6.88c-0.31,0.43-0.78,0.87-1.18,1.1c-0.4,0.23-0.73,0.25-4.69,0.49 c-3.96,0.24-11.55,0.69-15.55,0.88c-4,0.2-4.42,0.14-4.8-0.05c-0.38-0.18-0.73-0.49-1.09-0.89 C471.56,373.51,471.2,373.04,470.69,367.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M486.59,345.07c-0.01,0.21-0.1,0.42-0.19,0.66c-0.09,0.24-0.18,0.5-0.24,0.76c-0.06,0.26-0.1,0.52-0.1,0.86 c-0.01,0.34,0.02,0.75,0.09,1.13c0.07,0.38,0.2,0.74,0.42,1.03c0.22,0.3,0.55,0.53,0.9,0.77c0.35,0.24,0.72,0.47,1.14,0.6 c0.42,0.13,0.89,0.15,1.37,0.1c0.49-0.05,0.99-0.19,1.44-0.42c0.45-0.23,0.84-0.57,1.13-0.92c0.29-0.35,0.47-0.72,0.55-1.09 c0.08-0.37,0.06-0.73-0.02-1.16c-0.08-0.43-0.21-0.94-0.37-1.4c-0.16-0.45-0.33-0.86-0.4-1.16c-0.07-0.31-0.03-0.51,0.05-0.85 c0.08-0.34,0.21-0.81,0.31-1.23c0.1-0.42,0.19-0.78,0.11-1.27c-0.08-0.49-0.32-1.09-0.68-1.53c-0.36-0.44-0.84-0.72-1.29-0.9 c-0.45-0.18-0.87-0.26-1.33-0.28c-0.47-0.02-0.98,0.01-1.46,0.19c-0.48,0.18-0.92,0.52-1.26,0.93c-0.34,0.41-0.57,0.88-0.74,1.39 c-0.18,0.5-0.3,1.02-0.3,1.44c0,0.41,0.12,0.71,0.27,0.99c0.14,0.27,0.31,0.52,0.43,0.75 C486.54,344.66,486.61,344.87,486.59,345.07z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st80",
    x1: 476.34,
    y1: 374.91,
    x2: 473.82,
    y2: 334.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 480.42,
    y1: 374.97,
    x2: 477.91,
    y2: 334.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M505.39,556.54c-1.36-10.11,5.73-19.41,15.84-20.77c10.11-1.36,19.41,5.73,20.77,15.84 c1.36,10.11-5.73,19.41-15.84,20.77C516.05,573.74,506.75,566.64,505.39,556.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M504.13,547.19c-1.36-10.11,5.73-19.41,15.84-20.77c10.11-1.36,19.41,5.73,20.77,15.84 c1.36,10.11-5.73,19.41-15.84,20.77C514.79,564.39,505.49,557.3,504.13,547.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M502.92,538.23c-1.36-10.11,5.73-19.41,15.84-20.77c10.11-1.36,19.41,5.73,20.77,15.84 c1.36,10.11-5.73,19.41-15.84,20.77C513.58,555.43,504.28,548.34,502.92,538.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M511.35,531.46l3.52-0.47c-0.86,1.51-1.29,3.09-1.29,4.72l4.66-0.63c0.31-1.82,0.93-3.27,1.86-4.37 c0.94-1.09,2.01-1.72,3.22-1.88c1.4-0.19,2.65,0.12,3.75,0.94c1.1,0.82,1.92,2.08,2.47,3.79l3.15-0.42l0.32,2.4l-3.15,0.42 c-0.04,1.76-0.47,3.51-1.29,5.27l-3.38,0.46c1.1-1.92,1.67-3.7,1.73-5.33l-5.54,0.75c-0.34,3.58-1.94,5.56-4.77,5.94 c-1.3,0.18-2.49-0.14-3.57-0.95c-1.08-0.81-1.82-2-2.22-3.57l-1.03,0.14l-0.32-2.4l1.03-0.14 C510.37,534.73,510.65,533.18,511.35,531.46L511.35,531.46z M517.71,537.59l-3.79,0.51c0.49,1.23,1.19,1.79,2.1,1.67 C516.9,539.65,517.46,538.93,517.71,537.59L517.71,537.59z M521.84,534.59l4.71-0.63c-0.54-1.42-1.39-2.06-2.56-1.9 C522.87,532.21,522.16,533.05,521.84,534.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M521.08,216.92c2.63-0.25,7.67-0.97,12.02-2.37c4.35-1.39,8.02-3.47,10.82-5.86 c2.81-2.39,4.76-5.09,5.91-7.79c1.16-2.69,1.53-5.38,1.17-8.42c-0.35-3.04-1.43-6.42-3.26-9.5c-1.83-3.08-4.4-5.85-7.75-8.07 c-3.34-2.22-7.45-3.89-11.42-4.44c-3.98-0.56-7.82,0-11.11,1.89c-3.29,1.89-6.03,5.12-8.03,9.19c-2,4.07-3.25,8.97-3.89,12.71 c-0.65,3.73-0.7,6.3-0.65,8.01c0.05,1.71,0.2,2.58,0.63,3.02c0.43,0.44,1.14,0.47,2.53,0.59c1.4,0.13,3.48,0.36,5.04,0.7 c1.57,0.34,2.62,0.78,3.41,1.86c0.78,1.08,1.3,2.8,1.5,4.29c0.2,1.49,0.1,2.75,0.16,3.48 C518.22,216.97,518.44,217.18,521.08,216.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M512.79,230.57c1.24-0.49,2.62-2,3.47-4.6c0.84-2.6,1.15-6.29,1.26-8.79c0.11-2.5,0.03-3.81-0.29-5.11 c-0.32-1.3-0.88-2.59-1.64-3.46c-0.76-0.87-1.72-1.31-2.99-1.65c-1.28-0.33-2.87-0.55-4.27-0.74c-1.4-0.18-2.6-0.33-4.96,0.28 c-2.35,0.6-5.86,1.95-7.69,3.09c-1.83,1.14-2,2.08-1.56,2.73c0.44,0.65,1.49,1.02,3.35,2.02c1.85,1,4.51,2.64,6.29,4.37 c1.78,1.73,2.69,3.55,3.48,5.45c0.78,1.9,1.44,3.89,2.32,5.14C510.44,230.55,511.55,231.06,512.79,230.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M520.31,192.77l2.18-2.32c0.26,1.54,0.85,2.87,1.77,4.01l2.89-3.07c-0.81-1.44-1.2-2.8-1.17-4.09 c0.03-1.29,0.43-2.33,1.18-3.13c0.87-0.92,1.92-1.41,3.14-1.47c1.23-0.05,2.51,0.36,3.86,1.24l1.95-2.07l1.58,1.49l-1.95,2.07 c0.96,1.25,1.66,2.71,2.08,4.4l-2.1,2.23c-0.32-1.95-0.92-3.52-1.81-4.68l-3.43,3.65c1.78,2.68,1.79,4.96,0.03,6.83 c-0.81,0.86-1.81,1.31-3.02,1.36c-1.21,0.05-2.39-0.36-3.56-1.23l-0.64,0.68l-1.58-1.49l0.64-0.68 C521.47,195.6,520.79,194.36,520.31,192.77L520.31,192.77z M528.2,193.45l-2.35,2.5c1.04,0.58,1.84,0.58,2.4-0.02 C528.8,195.34,528.78,194.52,528.2,193.45L528.2,193.45z M529.38,189.03l2.92-3.1c-1.18-0.69-2.13-0.65-2.85,0.12 C528.75,186.79,528.73,187.78,529.38,189.03z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M469.4,265.72c-0.92,1-2.36,3.24-3.76,5.32c-1.4,2.08-2.76,4-3.6,6.4c-0.84,2.4-1.16,5.28-0.84,8.08 c0.32,2.8,1.28,5.52,2.62,7.67c1.34,2.15,3.07,3.74,5.3,4.44c2.23,0.7,4.96,0.53,7.98-0.86c3.02-1.39,6.32-3.99,9.45-6.86 c3.13-2.86,6.08-5.99,7.72-7.73c1.64-1.74,1.96-2.1,1.02-3c-0.94-0.9-3.13-2.33-6.89-4.55c-3.76-2.22-9.09-5.23-12.23-6.93 c-3.14-1.7-4.1-2.1-4.78-2.42C470.72,264.96,470.32,264.72,469.4,265.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M505.36,268.72c4.4-5.36,13.52-16.8,19.88-24.6c6.36-7.8,9.96-11.96,12.8-15.6 c2.84-3.64,4.92-6.76,6.56-9.96c1.64-3.2,2.84-6.48,3.56-8.6c0.72-2.12,0.96-3.08,0.92-3.56c-0.04-0.48-0.36-0.48-1.16,0.28 c-0.8,0.76-2.08,2.28-3.88,3.8c-1.8,1.52-4.12,3.04-6.56,4.2c-2.44,1.16-5,1.96-7.48,2.56c-2.48,0.6-4.88,1-6.52,1.2 c-1.64,0.2-2.52,0.2-2.96,0.48c-0.44,0.28-0.44,0.84-0.64,2.16c-0.2,1.32-0.6,3.4-1.04,5.2c-0.44,1.8-0.92,3.32-1.8,4.44 c-0.88,1.12-2.16,1.84-3.32,2.28c-1.16,0.44-2.2,0.6-2.68,0.76c-0.48,0.16-0.4,0.32-0.12,0.6c0.28,0.28,0.76,0.68,0.92,1.04 c0.16,0.36,0,0.68,0.48,1.16c0.48,0.48,1.6,1.12,2.72,1.72s2.24,1.16,2.96,1.64c0.72,0.48,1.04,0.88,0.96,1.52 c-0.08,0.64-0.56,1.52-3.52,6.76c-2.96,5.24-8.4,14.84-11.28,20C501.28,273.36,500.96,274.08,505.36,268.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M524.4,249.04c-2.48,2.64-7.12,8.56-9.36,11.72c-2.24,3.16-2.08,3.56,2.88,8 c4.96,4.44,14.72,12.92,19.84,17.44c5.12,4.52,5.6,5.08,5.96,5.88c0.36,0.8,0.6,1.84,0.28,2.88c-0.32,1.04-1.2,2.08-1.48,2.72 c-0.28,0.64,0.04,0.88,0.52,1.32c0.48,0.44,1.12,1.08,1.24,1.64c0.12,0.56-0.28,1.04-2.08,2.88c-1.8,1.84-5,5.04-6.68,6.72 c-1.68,1.68-1.84,1.84-1.76,1.96c0.08,0.12,0.4,0.2,3.64,0.4c3.24,0.2,9.4,0.52,12.52,0.44c3.12-0.08,3.2-0.56,2.92-2.92 c-0.28-2.36-0.92-6.6-1.52-10.32c-0.6-3.72-1.16-6.92-1.24-10.84c-0.08-3.92,0.32-8.56,1.6-13.28c1.28-4.72,3.44-9.52,3.72-11.44 c0.28-1.92-1.32-0.96-5.36,0.72c-4.04,1.68-10.52,4.08-14,5.04c-3.48,0.96-3.96,0.48-4.88-3.48c-0.92-3.96-2.28-11.4-3.12-15.44 C527.2,247.04,526.88,246.4,524.4,249.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M525.44,322.88c-2.56,2.56-7.44,7.84-9.8,10.6c-2.36,2.76-2.2,3,0.52,3.16c2.72,0.16,8,0.24,10.64,0.2 c2.64-0.04,2.64-0.2,2.44-0.4c-0.2-0.2-0.6-0.44-0.84-0.88c-0.24-0.44-0.32-1.08-0.36-2.2c-0.04-1.12-0.04-2.72,0.04-4.92 c0.08-2.2,0.24-5,0.2-6.48C528.24,320.48,528,320.32,525.44,322.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M469.14,305.16c-0.14,5.4-0.11,16.2,0.05,21.92c0.16,5.72,0.44,6.36,4.79,6.36c4.34,0,12.74-0.64,17.06-1.08 c4.32-0.44,4.56-0.68,0.92-4.32c-3.64-3.64-11.16-10.68-14.96-14.56c-3.8-3.88-3.88-4.6-3.72-5.4c0.16-0.8,0.56-1.68,2.2-3.64 c1.64-1.96,4.52-5,5.96-6.64c1.44-1.64,1.44-1.88,0.6-1.56c-0.84,0.32-2.52,1.2-4.28,1.92c-1.76,0.72-3.6,1.28-4.92,1.52 c-1.32,0.24-2.12,0.16-2.68,0.12C469.6,299.76,469.28,299.76,469.14,305.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M471.84,379.32c0.08,2.04,0.64,5.88,1.08,7.92c0.44,2.04,0.76,2.28,6,1.36c5.24-0.92,15.4-3,20.24-4.12 c4.84-1.12,4.36-1.28,3.64-1.96c-0.72-0.68-1.68-1.88-2.24-3.2c-0.56-1.32-0.72-2.76-0.92-3.48c-0.2-0.72-0.44-0.72-4.96-0.44 c-4.52,0.28-13.32,0.84-17.92,1.24C472.16,377.04,471.76,377.28,471.84,379.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M531,424.52c1-0.44,3.08-0.92,4.12-1c1.04-0.08,1.04,0.24,0.76,3.68c-0.28,3.44-0.84,10-0.9,17.58 c-0.06,7.58,0.38,16.19,0.3,18.91c-0.08,2.72-0.68-0.45-1.94-2.75c-1.26-2.3-3.18-3.74-5.74-4.86c-2.56-1.12-5.76-1.92-6.54-2.69 c-0.78-0.77,0.87-1.52,2.91-2.08c2.04-0.56,4.47-0.93,6.25-1.48c1.78-0.55,2.9-1.27,3.42-2.43c0.52-1.16,0.44-2.76-0.24-6.44 c-0.68-3.68-1.96-9.44-2.64-12.52C530.08,425.36,530,424.96,531,424.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M526.24,498.24c1.65-2.09,4.66-6.25,6.68-10.38c2.03-4.13,3.09-8.25,3.32-11.95 c0.23-3.71-0.37-7.01-1.52-9.74c-1.15-2.73-2.84-4.87-5.29-6.74c-2.45-1.86-5.66-3.45-9.18-4.27c-3.51-0.82-7.33-0.89-11.28-0.02 c-3.95,0.88-8.03,2.69-11.22,5.19c-3.18,2.5-5.47,5.68-6.4,9.39c-0.93,3.71-0.5,7.96,1.06,12.26c1.56,4.29,4.25,8.63,6.5,11.72 c2.26,3.08,4.09,4.91,5.37,6.07c1.28,1.16,2.01,1.66,2.63,1.66c0.62,0,1.13-0.5,2.2-1.42c1.07-0.92,2.69-2.27,4.04-3.17 c1.34-0.9,2.4-1.36,3.74-1.17c1.33,0.19,2.94,1.02,4.17,1.91c1.22,0.89,2.06,1.85,2.64,2.32 C524.27,500.35,524.58,500.33,526.24,498.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M530.36,513.79c0.51-1.25,0.38-3.31-0.92-5.74c-1.3-2.43-3.76-5.23-5.5-7.06 c-1.74-1.83-2.75-2.68-3.92-3.36c-1.17-0.68-2.5-1.17-3.66-1.23c-1.16-0.06-2.15,0.33-3.29,1.02c-1.13,0.69-2.41,1.7-3.52,2.59 c-1.11,0.89-2.06,1.66-3.27,3.79c-1.21,2.13-2.68,5.62-3.14,7.75c-0.45,2.13,0.11,2.91,0.89,3.04c0.78,0.13,1.78-0.37,3.81-1.02 c2.02-0.65,5.07-1.43,7.57-1.52c2.5-0.09,4.46,0.53,6.39,1.29c1.93,0.76,3.83,1.67,5.36,1.91 C528.69,515.49,529.85,515.04,530.36,513.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M508.16,481.9l-0.16-3.21c1.3,0.89,2.68,1.4,4.15,1.52l-0.21-4.25c-1.62-0.42-2.88-1.09-3.79-2.01 c-0.91-0.93-1.39-1.94-1.45-3.04c-0.06-1.28,0.31-2.38,1.13-3.31c0.82-0.93,2.02-1.57,3.6-1.93l-0.14-2.86l2.19-0.11l0.14,2.86 c1.58,0.17,3.13,0.69,4.65,1.57l0.15,3.08c-1.64-1.13-3.2-1.79-4.67-1.96l0.25,5.04c3.2,0.58,4.86,2.17,4.98,4.75 c0.06,1.19-0.32,2.23-1.12,3.14c-0.81,0.91-1.94,1.48-3.39,1.72l0.05,0.94l-2.19,0.11l-0.05-0.94 C511.03,483.04,509.65,482.67,508.16,481.9L508.16,481.9z M514.17,476.65l0.17,3.46c1.15-0.35,1.7-0.93,1.66-1.76 C515.96,477.54,515.35,476.97,514.17,476.65L514.17,476.65z M511.79,472.7l-0.21-4.28c-1.32,0.37-1.96,1.09-1.9,2.16 C509.72,471.59,510.43,472.3,511.79,472.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M491.72,216c-0.76,1.04-1.8,3.04-2.48,4.52c-0.68,1.48-1,2.44-0.88,2.92c0.12,0.48,0.68,0.48,2.24,1.2 c1.56,0.72,4.12,2.16,5.6,2.56c1.48,0.4,1.88-0.24,2.6-0.32c0.72-0.08,1.76,0.4,2.4,0.48c0.64,0.08,0.88-0.24,1.52-0.2 c0.64,0.04,1.68,0.44,2.24,0.56c0.56,0.12,0.64-0.04,0.4-0.72c-0.24-0.68-0.8-1.88-1.56-3.16c-0.76-1.28-1.72-2.64-3.2-3.92 c-1.48-1.28-3.48-2.48-4.76-3.32c-1.28-0.84-1.84-1.32-2.36-1.52C492.96,214.88,492.48,214.96,491.72,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M491.12,486.92c0.16,3.4,1.36,12.52,3,23.56c1.64,11.04,3.72,24,5.08,30c1.36,6,2,5.04,2,2.28 c0-2.76-0.64-7.32-0.44-10.88c0.2-3.56,1.24-6.12,2.56-8.24c1.32-2.12,2.92-3.8,3.72-4.8c0.8-1,0.8-1.32-0.08-1.4 c-0.88-0.08-2.64,0.08-4-0.52c-1.36-0.6-2.32-1.96-2.48-3.68c-0.16-1.72,0.48-3.8,1.2-5.92c0.72-2.12,1.52-4.28,0.96-6.28 c-0.56-2-2.48-3.84-4.36-5.96c-1.88-2.12-3.72-4.52-5.08-6.88C491.84,485.84,490.96,483.52,491.12,486.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M514.96,611.6c-1.04,0.24-1.68,1.04-1.6,2.24c0.08,1.2,0.88,2.8,1.8,4.32c0.92,1.52,1.96,2.96,3.04,4 c1.08,1.04,2.2,1.68,3.56,2.08c1.36,0.4,2.96,0.56,4.92,0.16c1.96-0.4,4.28-1.36,5.92-2.56c1.64-1.2,2.6-2.64,3.28-3.68 c0.68-1.04,1.08-1.68,1.48-1.96c0.4-0.28,0.8-0.2,1.08-0.68c0.28-0.48,0.44-1.52,0.64-2.36c0.2-0.84,0.44-1.48-0.44-1.76 c-0.88-0.28-2.88-0.2-6.36-0.04c-3.48,0.16-8.44,0.4-11.64,0.36C517.44,611.68,516,611.36,514.96,611.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M534.68,573.4c0.84,0.2,2.6,0.2,3.64,0.36c1.04,0.16,1.36,0.48,1.64,1c0.28,0.52,0.52,1.24,0.64,2.36 c0.12,1.12,0.12,2.64,0.16,3.32c0.04,0.68,0.12,0.52,0.44-1.72c0.32-2.24,0.88-6.56,1.36-9.92c0.48-3.36,0.88-5.76,1-6.92 c0.12-1.16-0.04-1.08-0.56-0.04c-0.52,1.04-1.4,3.04-2.44,4.64c-1.04,1.6-2.24,2.8-3.36,3.72c-1.12,0.92-2.16,1.56-2.72,2.08 C533.92,572.8,533.84,573.2,534.68,573.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M508.72,569.16c0.32,0.92,1.28,2.92,2.16,5.36c0.88,2.44,1.68,5.32,2.16,6.88c0.48,1.56,0.64,1.8,0.72,1.24 c0.08-0.56,0.08-1.92,0.08-3.04s0-2,0.08-2.64c0.08-0.64,0.24-1.04,0.6-1.36c0.36-0.32,0.92-0.56,1.6-0.68 c0.68-0.12,1.48-0.12,1.92-0.2c0.44-0.08,0.52-0.24,0.28-0.4c-0.24-0.16-0.8-0.32-1.72-0.64c-0.92-0.32-2.2-0.8-3.36-1.48 c-1.16-0.68-2.2-1.56-2.88-2.2c-0.68-0.64-1-1.04-1.32-1.32C508.72,568.4,508.4,568.24,508.72,569.16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadtoHeadMeVsYou);
export default __webpack_public_path__ + "static/media/Head to Head Me Vs You.bd8dcaaff1fa778e96db8038a746ed4b.svg";
export { ForwardRef as ReactComponent };